/* =============================================================================
   Header-Menue — Logik
   =============================================================================
   Lag bis 2026-07-30 als Inline-<script> in blocks/menu.liquid und war mit 153.155
   Zeichen der groesste Einzelblock des Dokuments — 43 Prozent des ausgelieferten HTML
   waren Inline-JavaScript. Inline-Code ist NICHT zwischenspeicherbar: dieselben Bytes
   kamen bei jedem Seitenaufruf neu ueber die Leitung und mussten jedes Mal geparst
   werden. Als Datei wird er einmal geladen und gilt fuer den ganzen Besuch.

   ⚠️ Das <script> traegt `defer`, und das ist nachgewiesen unbedenklich: diese Datei tut
   zur Parse-Zeit ohnehin nichts. Sie endet mit
   `if (document.readyState === 'loading') addEventListener('DOMContentLoaded', boot) else boot()`.
   Als Inline-Skript war readyState 'loading' — es wurde also nur ein Zuhoerer registriert und
   die ganze Layout-Arbeit (applyOverflowNav, applyRadialNav, Megamenue-Umformung) lief erst bei
   DOMContentLoaded. Mit `defer` laeuft die Datei am Ende des Parsens, readyState ist dann
   'interactive', der else-Zweig greift und boot() startet an praktisch derselben Stelle.

   ⚠️ Was vor dem ersten Paint stehen MUSS, liegt weiterhin inline in menu.liquid: die
   beiden kleinen Bloecke, die die Header-Klassen aus data-Attributen setzen und die
   Pillenlaenge im Spine-Modus angleichen. Die duerfen NICHT hierher wandern.
   ============================================================================= */

(function () {
    'use strict';

    // --- Sync menu-block state → parent .ne-header modifier classes -------
    function syncHeaderClasses(marker) {
      var header = document.querySelector('.ne-header');
      if (!header || !marker) return;
      var d = marker.dataset;
      var classes = header.classList;

      var drop = [];
      for (var i = 0; i < classes.length; i++) {
        var c = classes[i];
        if (
          c === 'ne-header--burger-mode' ||
          c.indexOf('ne-header--nav-btn-') === 0 ||
          c.indexOf('ne-header--nav-arrange-') === 0 ||
          c === 'ne-header--radial-sunburst' ||
          c.indexOf('ne-header--below-') === 0 ||
          c === 'ne-header--nav-equal-width' ||
          c.indexOf('ne-header--dropdown-') === 0 ||
          c === 'ne-header--actions-shape' ||
          c.indexOf('ne-header--hover-style-') === 0 ||
          c.indexOf('ne-header--ul-') === 0 ||
          c === 'ne-header--nav-dd-trace' ||
          c === 'ne-header--hover-bold' ||
          c === 'ne-header--nav-dim' ||
          c === 'ne-header--nav-hidden' ||
          c === 'ne-header--nav-scroll-reveal' ||
          c === 'ne-header--nav-scrolling' ||
          c.indexOf('ne-header--nav-sanim-') === 0 ||
          c.indexOf('ne-header--nav-hint-') === 0 ||
          c === 'ne-header--btn-effect' ||
          c === 'ne-header--btn-menu' ||
          c === 'ne-header--btn-menu-bg'
        ) drop.push(c);
      }
      drop.forEach(function (c) { classes.remove(c); });

      // getAttribute over dataset: HTML spec only camelCases `-` followed
      // by a lowercase letter, so `data-ne-btn-3d` would be accessed as
      // dataset['neBtn-3D'] (with the dash kept before the digit), not
      // dataset.neBtn3d. The attribute is now `data-ne-btn3d`, but we use
      // getAttribute throughout to stay robust against future renames.
      var attr = function (n) { return marker.getAttribute(n) || ''; };

      var mode = attr('data-ne-nav-mode') || 'text';
      if (mode === 'burger') classes.add('ne-header--burger-mode');

      var arrange = attr('data-ne-nav-arrange') || 'inline';
      classes.add('ne-header--nav-arrange-' + arrange);
      // Radial nav scatters the points as absolute satellites around the logo — the
      // header↔frame WELD/MERGE (which reshapes the header BAR to fuse with the frame)
      // fights that layout, so suppress it whenever radial is active (user 2026-07-12).
      // Liquid already gates it off on a full render (_nav_radial), but a block-only
      // Customizer re-render can leave stale weld classes, so strip them here too and
      // record them so switching back OUT of radial restores them without a full re-render.
      var _weldCls = ['ne-header--frame-weld', 'ne-header--frame-merge', 'ne-header--frame-mouth'];
      if (arrange === 'radial') {
        var _sup = [];
        _weldCls.forEach(function (c) { if (classes.contains(c)) { classes.remove(c); _sup.push(c); } });
        if (_sup.length) header.setAttribute('data-ne-weld-suppressed', _sup.join(' '));
      } else {
        var _prevWeld = header.getAttribute('data-ne-weld-suppressed');
        if (_prevWeld) {
          _prevWeld.split(' ').forEach(function (c) { if (c) classes.add(c); });
          header.removeAttribute('data-ne-weld-suppressed');
        }
      }
      if (arrange === 'radial' && attr('data-ne-radial-orient') === 'sunburst') {
        classes.add('ne-header--radial-sunburst');
      }
      if (arrange === 'below') {
        classes.add('ne-header--below-align-' + (attr('data-ne-below-align') || 'center'));
        if (attr('data-ne-below-ul-edge') === '1') classes.add('ne-header--below-underline-edge');
      }
      if (attr('data-ne-nav-equal-width') === '1') classes.add('ne-header--nav-equal-width');

      if (attr('data-ne-nav-dim') === '1') classes.add('ne-header--nav-dim');
      if (attr('data-ne-nav-hidden') === '1') {
        classes.add('ne-header--nav-hidden');
        classes.add('ne-header--nav-hint-' + (attr('data-ne-nav-hint') || 'bar'));
      }
      if (attr('data-ne-nav-scroll-reveal') === '1') {
        classes.add('ne-header--nav-scroll-reveal');
        classes.add('ne-header--nav-sanim-' + (attr('data-ne-nav-scroll-anim') || 'fade'));
      }

      var style = attr('data-ne-button-style') || 'none';
      if (style !== 'none') classes.add('ne-header--nav-btn-' + style);

      if (attr('data-ne-btn3d') === '1' && style !== 'none') classes.add('ne-header--nav-btn-3d');
      if (attr('data-ne-btn-glass') === '1' && style !== 'none') classes.add('ne-header--nav-btn-glass');
      if (attr('data-ne-actions-shape') === '1' && style !== 'none') classes.add('ne-header--actions-shape');

      // Hover treatment — only when no persistent button style (mirrors the
      // visible_if on the menu block). Shape appears on hover; underline/bold
      // are extra hover cues. Applies to action-icons too when actions-shape
      // is on (but actions-shape requires style!='none', so for the hover-only
      // case actions follow via the .ne-header--hover-* + base actions rules).
      var hoverStyle = attr('data-ne-hover-style') || 'none';
      if (style === 'none') {
        if (hoverStyle !== 'none') classes.add('ne-header--hover-style-' + hoverStyle);
        var ulEffect = attr('data-ne-ul-effect') || 'none';
        if (ulEffect !== 'none') classes.add('ne-header--ul-' + ulEffect);
        if (attr('data-ne-hover-bold') === '1') classes.add('ne-header--hover-bold');
      }
      if (attr('data-ne-dd-trace') === '1') classes.add('ne-header--nav-dd-trace');
      if (attr('data-ne-dd-text-couple') === '1') classes.add('ne-header--dropdown-text-couple');
      classes.add('ne-header--mm-sub-' + (attr('data-ne-mm-sub') || 'columns'));
      if (attr('data-ne-btn-effect') === '1' && attr('data-ne-header-effect') !== 'none') classes.add('ne-header--btn-effect');

      var anim = attr('data-ne-dropdown-animation') || 'fade';
      // Merge menu with header: the dropdown/mega becomes a seamless downward
      // extension of the header. Couples the slide-down reveal (user choice).
      // Glass is NOT forced — merge-specific slide rules in header-styles apply
      // the transition regardless of the glass/transparent gate, so the menu's
      // own Glass setting stays authoritative.
      var menuMerge = attr('data-ne-menu-merge') === '1';
      if (menuMerge) { anim = 'slide'; classes.add('ne-header--menu-merge'); }
      classes.add('ne-header--dropdown-' + anim);
      if ((attr('data-ne-dropdown-scheme-mode') || 'inherit') === 'custom') classes.add('ne-header--dropdown-scheme');

      if ((attr('data-ne-dropdown-style') || 'panel') === 'buttons') {
        classes.add('ne-header--btn-menu');
        if (attr('data-ne-buttons-bg') === '1') classes.add('ne-header--btn-menu-bg');
      }

      if (attr('data-ne-dropdown-soft-edge') === '1') classes.add('ne-header--dropdown-soft-edge');
      if (attr('data-ne-dropdown-se-flip') === '1') classes.add('ne-header--dropdown-se-flip');
      if (attr('data-ne-dropdown-se-couple') === '1') classes.add('ne-header--dropdown-se-couple');
      if (attr('data-ne-dropdown-custom-optics') === '1') classes.add('ne-header--dropdown-custom-optics');
      if (attr('data-ne-dropdown-glass') === '1') classes.add('ne-header--dropdown-glass');
      var ddEffect = attr('data-ne-dropdown-effect') || 'none';
      if (ddEffect !== 'none') classes.add('ne-header--dropdown-effect-' + ddEffect);
      if (attr('data-ne-dropdown-glass-tint') === '1') classes.add('ne-header--dropdown-glass-tint');
    }

    // --- Pairing engine ---------------------------------------------------
    // Collects icon_item + megamenu_link templates rendered inside the
    // block-islands container, pairs them to nav slots, and mutates the
    // SSR markup (icon span replaces default SVG; megamenu panel replaces
    // plain dropdown + moves its items into the links slot).
    function collectTemplates(scope) {
      return {
        icons: Array.prototype.slice.call(scope.querySelectorAll('template[data-ne-icon-item]')),
        megas: Array.prototype.slice.call(scope.querySelectorAll('template[data-ne-megamenu-link]')),
        carousels: Array.prototype.slice.call(scope.querySelectorAll('template[data-ne-drawer-carousel]'))
      };
    }

    // URL equality — tolerates trailing-slash, querystring, fragment, and
    // scheme differences between the Shopify URL picker value and the
    // resolved link_list URL. In practice the pin can be absolute
    // (`https://shop.com/foo/`), relative (`/foo`), or a shopify scheme
    // (`shopify://collections/bar`) — all of which must match the resolved
    // link.url (always a relative path like `/collections/bar`).
    //
    // Home-page alias: picking "Home page" in the Shopify URL picker emits
    // `/collections/frontpage` (the legacy frontpage route), but a menu's
    // home link typically resolves to `/`. Both refer to the same page, so
    // we normalize both sides to `/` before comparing.
    function sameUrl(a, b) {
      if (!a || !b) return false;
      if (a === b) return true;
      var toPath = function (s) {
        var v = String(s).trim();
        var m = v.match(/^shopify:\/\/(.+)$/);
        if (m) v = '/' + m[1].replace(/^\/+/, '');
        try {
          v = new URL(v, location.origin).pathname;
        } catch (_) {
          v = v.replace(/^https?:\/\/[^/]+/i, '') || v;
        }
        // Normalize Shopify's frontpage aliases to '/'
        if (v === '/collections/frontpage' || v === '/collections/frontpage/') v = '/';
        return v;
      };
      var norm = function (s) { return String(s).replace(/\/+$/, '').toLowerCase() || '/'; };
      return norm(toPath(a)) === norm(toPath(b));
    }

    // Icon pairing — URL pin first, then positional fallback for unpinned
    // blocks against still-unpaired links. Returns an array of
    // { li, tpl, mode, bi } decisions (bi = block index, 0-based).
    function pairIcons(slots, iconTemplates) {
      var decisions = [];
      var used = new Set();
      var paired = new Set();

      // Pass 1: URL pins
      slots.forEach(function (li) {
        var url = li.getAttribute('data-ne-nav-url');
        for (var i = 0; i < iconTemplates.length; i++) {
          if (used.has(i)) continue;
          var pin = iconTemplates[i].getAttribute('data-ne-menu-link');
          if (pin && sameUrl(pin, url)) {
            decisions.push({ li: li, tpl: iconTemplates[i], mode: 'pinned', bi: i });
            used.add(i);
            paired.add(li);
            break;
          }
        }
      });

      // Pass 2: positional fallback (only unpinned blocks into unpaired slots)
      var unpinnedBlocks = [];
      for (var k = 0; k < iconTemplates.length; k++) {
        if (used.has(k)) continue;
        if (!iconTemplates[k].getAttribute('data-ne-menu-link')) {
          unpinnedBlocks.push({ tpl: iconTemplates[k], bi: k });
        }
      }
      var unpairedSlots = slots.filter(function (li) { return !paired.has(li); });
      var cap = Math.min(unpinnedBlocks.length, unpairedSlots.length);
      for (var j = 0; j < cap; j++) {
        decisions.push({
          li: unpairedSlots[j],
          tpl: unpinnedBlocks[j].tpl,
          mode: 'positional',
          bi: unpinnedBlocks[j].bi
        });
        used.add(unpinnedBlocks[j].bi);
      }

      return { decisions: decisions, usedIdx: used };
    }

    function applyIconDecision(d) {
      var iconUrl = d.tpl.getAttribute('data-ne-icon-url');
      var label = d.tpl.getAttribute('data-ne-label');
      var a = d.li.querySelector('[data-ne-icon-target]');
      if (a && iconUrl) {
        // Mirror the drawer path: build the span + setProperty instead of
        // interpolating the URL into an innerHTML string.
        a.textContent = '';
        var _ico = document.createElement('span');
        _ico.className = 'ne-header__nav-icon-img';
        _ico.setAttribute('aria-hidden', 'true');
        _ico.style.setProperty('--ne-nav-icon-url', "url('" + iconUrl + "')");
        a.appendChild(_ico);
      }
      if (label) {
        if (a) a.setAttribute('aria-label', label);
        var lbl = d.li.querySelector('.ne-header__nav-icon-label');
        if (lbl) lbl.textContent = label;
      }
    }

    // Megamenu pairing — URL pin first, then positional fallback (Horizon
    // style): unpinned block N attaches to the Nth unpaired parent-link
    // that has children. Leaf links (no children) can't host a megamenu
    // and are skipped. Decisions carry mode: 'pinned'|'positional'.
    function pairMegamenus(slots, megaTemplates) {
      var decisions = [];
      var used = new Set();
      var paired = new Set();

      // Pass 1: URL pins
      slots.forEach(function (li) {
        var url = li.getAttribute('data-ne-nav-url');
        for (var i = 0; i < megaTemplates.length; i++) {
          if (used.has(i)) continue;
          var pin = megaTemplates[i].getAttribute('data-ne-menu-link');
          if (pin && sameUrl(pin, url)) {
            decisions.push({ li: li, tpl: megaTemplates[i], mode: 'pinned', bi: i });
            used.add(i);
            paired.add(li);
            break;
          }
        }
      });

      // Pass 2: positional fallback — unpinned blocks into unpaired
      // dropdown-parent slots only. Leaf links are unsuitable hosts.
      var unpinnedBlocks = [];
      for (var k = 0; k < megaTemplates.length; k++) {
        if (used.has(k)) continue;
        if (!megaTemplates[k].getAttribute('data-ne-menu-link')) {
          unpinnedBlocks.push({ tpl: megaTemplates[k], bi: k });
        }
      }
      var parentSlots = slots.filter(function (li) {
        return !paired.has(li) && li.classList.contains('ne-header__nav-item--has-dropdown');
      });
      var cap = Math.min(unpinnedBlocks.length, parentSlots.length);
      for (var j = 0; j < cap; j++) {
        decisions.push({
          li: parentSlots[j],
          tpl: unpinnedBlocks[j].tpl,
          mode: 'positional',
          bi: unpinnedBlocks[j].bi
        });
        used.add(unpinnedBlocks[j].bi);
      }

      return { decisions: decisions, usedIdx: used };
    }

    // Inject drawer carousel template(s) into matching parent accordion's
    // slot. Keyed by URL (pin) matching the accordion's data-ne-nav-url.
    // Also handles positional fallback: unpinned drawer-carousel N → Nth
    // unpaired accordion with children. Mirrors the megamenu pairing pattern.
    // Horizon-style: all megamenu carousel templates render in a single slot
    // at the bottom of the drawer (above the footer), not paired to a
    // specific accordion. Blocks emit in order; injection preserves that order.
    function injectDrawerCarousels(drawerRoot, carouselTemplates) {
      if (!drawerRoot) return;
      var slot = drawerRoot.parentNode
        ? drawerRoot.parentNode.querySelector('[data-ne-drawer-carousel-slot]')
        : null;
      if (!slot) return;
      slot.innerHTML = '';
      carouselTemplates.forEach(function (tpl) {
        slot.appendChild(tpl.content.cloneNode(true));
      });
    }

    // Inline-accordion chevron (shared SVG string — keep in sync with drawer chevron).
    var MM_ACCORDION_CHEVRON = '<svg class="ne-header__megamenu-accordion-chevron" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';

    // Convert a plain-dropdown cascading submenu item into a <details> accordion.
    // Source: .ne-header__dropdown-item--has-submenu (label anchor + nested submenu div)
    // Target: <details class="ne-header__megamenu-accordion">
    //   <summary>[label][chevron]</summary>
    //   <div>[view-all anchor][...grandchildren]</div>
    // </details>
    function megamenuAccordionize(node) {
      var triggerLink = node.querySelector(':scope > .ne-header__dropdown-link');
      var submenu = node.querySelector(':scope > .ne-header__dropdown--submenu');
      if (!triggerLink || !submenu) return null;

      var labelEl = triggerLink.querySelector('.ne-header__dropdown-link-label');
      var labelText = labelEl ? labelEl.textContent : triggerLink.textContent;

      var details = document.createElement('details');
      details.className = 'ne-header__megamenu-accordion';

      var summary = document.createElement('summary');
      summary.className = 'ne-header__megamenu-accordion-summary';
      summary.innerHTML =
        '<span class="ne-header__megamenu-accordion-label"></span>' +
        MM_ACCORDION_CHEVRON;
      summary.querySelector('.ne-header__megamenu-accordion-label').textContent = labelText;

      var content = document.createElement('div');
      content.className = 'ne-header__megamenu-accordion-content';
      Array.prototype.forEach.call(submenu.querySelectorAll(':scope > a'), function (a) {
        var clone = a.cloneNode(true);
        clone.classList.remove('ne-header__dropdown-link');
        clone.classList.add('ne-header__megamenu-accordion-link');
        if (a.classList.contains('ne-header__dropdown-link--view-all')) {
          clone.classList.remove('ne-header__dropdown-link--view-all');
          clone.classList.add('ne-header__megamenu-accordion-link--view-all');
        }
        content.appendChild(clone);
      });

      details.appendChild(summary);
      details.appendChild(content);
      return details;
    }

    // Merchant-chosen submenu reveal model (Customizer: megamenu_submenu_style).
    // Read from the header sync element so it's available before the header
    // class is derived. 'columns' | 'accordion' | 'flyout'.
    function getMmSub(scopeEl) {
      var hdr = scopeEl && scopeEl.closest ? scopeEl.closest('.ne-header') : null;
      var sync = (hdr && hdr.querySelector('[data-ne-header-sync]')) || document.querySelector('[data-ne-header-sync]');
      return (sync && sync.getAttribute('data-ne-mm-sub')) || 'columns';
    }

    // Build a submenu group as a heading + a list of its child links. Used by the
    // 'columns' mode (each group is its own always-open column) and 'flyout' mode
    // (the child list is hidden and revealed beside the heading on hover — pure
    // CSS, see .ne-header__megamenu-group--flyout). Mirrors megamenuAccordionize's
    // extraction but emits the group/list markup the mega CSS already styles.
    function megamenuGroupize(node, flyout) {
      var triggerLink = node.querySelector(':scope > .ne-header__dropdown-link');
      var submenu = node.querySelector(':scope > .ne-header__dropdown--submenu');
      if (!triggerLink || !submenu) return null;

      var labelEl = triggerLink.querySelector('.ne-header__dropdown-link-label');
      var labelText = labelEl ? labelEl.textContent : triggerLink.textContent;

      var group = document.createElement('div');
      group.className = 'ne-header__megamenu-group' + (flyout ? ' ne-header__megamenu-group--flyout' : '');

      var heading = document.createElement('a');
      heading.className = 'ne-header__megamenu-group-heading';
      heading.href = triggerLink.getAttribute('href') || '#';
      heading.textContent = labelText;
      if (flyout) heading.insertAdjacentHTML('beforeend', MM_ACCORDION_CHEVRON);

      var list = document.createElement('ul');
      list.className = 'ne-header__megamenu-list';
      Array.prototype.forEach.call(submenu.querySelectorAll(':scope > a'), function (a) {
        var li = document.createElement('li');
        var clone = a.cloneNode(true);
        clone.className = 'ne-header__megamenu-link' +
          (a.classList.contains('ne-header__dropdown-link--view-all') ? ' ne-header__megamenu-link--view-all' : '');
        li.appendChild(clone);
        list.appendChild(li);
      });

      group.appendChild(heading);
      group.appendChild(list);
      return group;
    }

    // Replace every has-submenu row in a links slot with the structure the chosen
    // mode wants (accordion <details> / group columns / hover flyout).
    function transformSubmenus(linksSlot, mode) {
      Array.prototype.forEach.call(
        linksSlot.querySelectorAll(':scope > .ne-header__dropdown-item--has-submenu'),
        function (node) {
          var built = mode === 'accordion'
            ? megamenuAccordionize(node)
            : megamenuGroupize(node, mode === 'flyout');
          if (built) node.parentNode.replaceChild(built, node);
        }
      );
    }

    // Build a "More" mega row from an overflowed nav-item WITHOUT dragging its own
    // megamenu/dropdown panel along (that opened a second mega over the first).
    // A leaf item → a plain dropdown-item row; an item with children → a
    // dropdown-item--has-submenu carrying its links, so transformSubmenus can then
    // render it exactly like any other submenu (columns / accordion / flyout).
    function buildMoreItem(item) {
      var a = item.querySelector('a[href]');
      var title = item.getAttribute('data-ne-nav-title') || (a ? a.textContent.trim() : '');
      var url = item.getAttribute('data-ne-nav-url') || (a ? a.getAttribute('href') : '#');
      var subAnchors = Array.prototype.slice.call(
        item.querySelectorAll('.ne-header__megamenu-links a[href], :scope > .ne-header__dropdown a.ne-header__dropdown-link[href]')
      ).filter(function (x) {
        return !x.classList.contains('ne-header__megamenu-group-heading') &&
               !x.classList.contains('ne-header__nav-link');
      });

      if (subAnchors.length === 0) {
        var leaf = document.createElement('div');
        leaf.className = 'ne-header__dropdown-item';
        var la = document.createElement('a');
        la.href = url; la.className = 'ne-header__dropdown-link'; la.setAttribute('role', 'menuitem');
        la.textContent = title;
        leaf.appendChild(la);
        return leaf;
      }

      var wrap = document.createElement('div');
      wrap.className = 'ne-header__dropdown-item ne-header__dropdown-item--has-submenu';
      var head = document.createElement('a');
      head.href = url; head.className = 'ne-header__dropdown-link';
      head.setAttribute('role', 'menuitem');
      head.setAttribute('aria-haspopup', 'true');
      head.setAttribute('aria-expanded', 'false');
      head.innerHTML = '<span class="ne-header__dropdown-link-label"></span>' +
        '<svg class="ne-header__dropdown-chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>';
      head.querySelector('.ne-header__dropdown-link-label').textContent = title;
      var sub = document.createElement('div');
      sub.className = 'ne-header__dropdown--submenu';
      subAnchors.forEach(function (sa) {
        var cl = document.createElement('a');
        cl.href = sa.getAttribute('href') || '#';
        cl.className = 'ne-header__dropdown-link';
        cl.setAttribute('role', 'menuitem');
        cl.textContent = sa.textContent.trim();
        sub.appendChild(cl);
      });
      wrap.appendChild(head);
      wrap.appendChild(sub);
      return wrap;
    }

    function promoteToMegamenu(d) {
      var dropdown = d.li.querySelector(':scope > .ne-header__dropdown');
      if (!dropdown) return false;
      var panelTpl = d.tpl.content.firstElementChild;
      if (!panelTpl) return false;
      var panel = panelTpl.cloneNode(true);

      var linksSlot = panel.querySelector('[data-ne-mm-links-slot]');
      if (linksSlot) {
        // Strip the narrow-dropdown connector trace before moving the links in
        // (it's display:none in a mega and only clutters the slot / column flow).
        var _tr = dropdown.querySelector(':scope > .ne-header__dropdown-trace');
        if (_tr) dropdown.removeChild(_tr);
        while (dropdown.firstChild) linksSlot.appendChild(dropdown.firstChild);
        // Transform cascading submenus per the merchant-chosen model
        // (accordion / columns / hover-flyout).
        transformSubmenus(linksSlot, getMmSub(d.li));
      }

      // Inherit scheme class from the plain dropdown if present.
      Array.prototype.forEach.call(dropdown.classList, function (c) {
        if (c.indexOf('color-scheme-') === 0 || c.indexOf('color-') === 0) panel.classList.add(c);
      });
      panel.setAttribute('aria-label', d.li.getAttribute('data-ne-nav-title') || '');

      dropdown.parentNode.replaceChild(panel, dropdown);
      d.li.classList.add('ne-header__nav-item--has-megamenu');
      return true;
    }

    // Global megamenu mode: once any megamenu_link block exists, ALL remaining
    // plain dropdowns are visually upgraded to megamenu panels (Horizon-style
    // — the whole menu system switches to panel UI, regardless of whether a
    // specific link has a dedicated megamenu block). Builds a minimal panel
    // shell (no aside — plain dropdowns have no featured/promo content),
    // moves the existing dropdown items into the links slot, and applies the
    // same submenu → accordion transform so cascading submenus render inline.
    function synthesizeMegamenu(li, megaTpl) {
      if (li.classList.contains('ne-header__nav-item--has-megamenu')) return false;
      var dropdown = li.querySelector(':scope > .ne-header__dropdown');
      if (!dropdown) return false;

      // Drop the connector-trace span first: it's a narrow-dropdown element
      // (display:none in a mega) that otherwise counts as a child → inflated the
      // column count (a 4-link dropdown counted 5) and left a phantom column slot.
      var _trace = dropdown.querySelector(':scope > .ne-header__dropdown-trace');
      if (_trace) dropdown.removeChild(_trace);
      // Columns follow SUBMENU groups, not a flat item count: a flat list of
      // links stays ONE column. Only the 'columns' mode spreads submenu groups
      // across columns (each group owns one); 'accordion' + 'flyout' keep a
      // single column (children expand inline / fly out on hover).
      var _mmSub = getMmSub(li);
      var subGroups = dropdown.querySelectorAll(':scope > .ne-header__dropdown-item--has-submenu').length;
      var cols = (_mmSub === 'columns' && subGroups >= 1) ? Math.min(3, subGroups) : 1;

      var panel = document.createElement('div');
      panel.className = 'ne-header__megamenu ne-header__megamenu--horizon ne-header__megamenu--synthetic';
      panel.setAttribute('role', 'menu');
      panel.setAttribute('aria-label', li.getAttribute('data-ne-nav-title') || '');
      panel.style.setProperty('--ne-mm-cols', cols);

      // Inherit scheme classes from the source dropdown so custom scheme is preserved.
      Array.prototype.forEach.call(dropdown.classList, function (c) {
        if (c.indexOf('color-scheme-') === 0 || c.indexOf('color-') === 0) panel.classList.add(c);
      });

      var inner = document.createElement('div');
      inner.className = 'ne-header__megamenu-inner';

      var linksSlot = document.createElement('div');
      linksSlot.className = 'ne-header__megamenu-links ne-header__megamenu-links--plain';
      linksSlot.style.setProperty('--ne-mm-link-cols', cols);
      linksSlot.setAttribute('data-ne-mm-links-slot', '');

      while (dropdown.firstChild) linksSlot.appendChild(dropdown.firstChild);
      transformSubmenus(linksSlot, _mmSub);

      inner.appendChild(linksSlot);
      // Clone the product/promo aside from the first configured megamenu so a
      // plain-dropdown mega (no dedicated block) shows the SAME cards — menus
      // with and without submenus then read identically (user 2026-07-02).
      if (megaTpl && megaTpl.content && megaTpl.content.firstElementChild) {
        var _srcAside = megaTpl.content.firstElementChild.querySelector('.ne-header__megamenu-aside');
        if (_srcAside) {
          inner.appendChild(_srcAside.cloneNode(true));
          panel.classList.add('ne-header__megamenu--has-aside');
        }
      }
      panel.appendChild(inner);

      dropdown.parentNode.replaceChild(panel, dropdown);
      li.classList.add('ne-header__nav-item--has-megamenu');
      li.classList.add('ne-header__nav-item--synthetic-megamenu');
      return true;
    }

    // Drawer icon pairing — same URL + positional rules as the desktop
    // icon nav, but injects icon-before-label on the drawer rows.
    function pairDrawerIcons(drawerRoot, iconTemplates) {
      if (!drawerRoot) return { decisions: [], usedIdx: new Set() };
      var rows = Array.prototype.slice.call(drawerRoot.querySelectorAll('[data-ne-drawer-slot]'));
      return pairIcons(rows, iconTemplates);
    }

    function applyDrawerIconDecision(d) {
      var iconUrl = d.tpl.getAttribute('data-ne-icon-url');
      var label = d.tpl.getAttribute('data-ne-label');
      if (iconUrl) {
        var labelEl = d.li.querySelector('[data-ne-drawer-label]');
        if (labelEl && !labelEl.querySelector('.ne-mobile-menu__link-icon')) {
          var iconSpan = document.createElement('span');
          iconSpan.className = 'ne-mobile-menu__link-icon';
          iconSpan.setAttribute('aria-hidden', 'true');
          iconSpan.style.setProperty('--ne-mobile-icon-url', "url('" + iconUrl + "')");
          labelEl.insertBefore(iconSpan, labelEl.firstChild);
          // Apply layout class to the clickable row ONLY — never to <details>,
          // because display:flex on details turns its summary + sub-div into
          // horizontal flex siblings (drawer rows wrap into columns).
          if (d.li.tagName === 'DETAILS') {
            var summary = d.li.querySelector('summary');
            if (summary) summary.classList.add('ne-mobile-menu__link--with-icon');
          } else {
            d.li.classList.add('ne-mobile-menu__link--with-icon');
          }
        }
      }
      if (label) {
        var lbl = d.li.querySelector('[data-ne-drawer-label]');
        if (lbl) {
          // Preserve the injected icon span if any
          var existing = lbl.querySelector('.ne-mobile-menu__link-icon');
          lbl.textContent = label;
          if (existing) lbl.insertBefore(existing, lbl.firstChild);
        }
      }
    }

    // --- Debugger overlay (Customizer-only) -------------------------------
    function escHtml(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }
    function escAttr(s) { return String(s == null ? '' : s).replace(/"/g, '&quot;'); }

    function renderPairingPreview(state) {
      var root = document.querySelector('[data-ne-icon-pairing-preview]');
      if (!root) return;
      // Only renders content in icon nav mode — the original Phase 1 scope.
      var navMode = root.getAttribute('data-nav-mode');
      if (navMode !== 'icon') { root.style.display = 'none'; return; }
      root.style.display = '';

      var okCount = 0, warnCount = 0, missCount = 0;
      var slotDecisions = new Map();
      state.iconDecisions.forEach(function (d) { slotDecisions.set(d.li, d); });

      var itemsHtml = state.slots.map(function (li, idx) {
        var title = li.getAttribute('data-ne-nav-title') || '';
        var url = li.getAttribute('data-ne-nav-url') || '';
        var d = slotDecisions.get(li);
        var iconStatus, iconCls;
        if (d) {
          var iconUrl = d.tpl.getAttribute('data-ne-icon-url');
          if (iconUrl) { iconStatus = 'Icon'; iconCls = 'ok'; okCount++; }
          else { iconStatus = 'No icon'; iconCls = 'warn'; warnCount++; }
        } else {
          iconStatus = 'No block'; iconCls = 'miss'; missCount++;
        }
        var modeStatus = '', modeCls = 'mode';
        if (d && d.mode === 'pinned') { modeStatus = 'Pinned · Block ' + (d.bi + 1); modeCls = 'pinned'; }
        else if (d && d.mode === 'positional') { modeStatus = 'Slot · Block ' + (d.bi + 1); modeCls = 'slot'; }
        return (
          '<li class="ne-icon-pairing-preview__item">' +
            '<span class="ne-icon-pairing-preview__idx">' + (idx + 1) + '.</span>' +
            '<span class="ne-icon-pairing-preview__label" title="' + escAttr(url) + '">' + escHtml(title) + '</span>' +
            (modeStatus ? '<span class="ne-icon-pairing-preview__status ne-icon-pairing-preview__status--' + modeCls + '">' + escHtml(modeStatus) + '</span>' : '') +
            '<span class="ne-icon-pairing-preview__status ne-icon-pairing-preview__status--' + iconCls + '">' + iconStatus + '</span>' +
          '</li>'
        );
      }).join('');

      var unused = [];
      for (var i = 0; i < state.iconTemplates.length; i++) {
        if (!state.usedIconIdx.has(i)) {
          var t = state.iconTemplates[i];
          unused.push({ i: i + 1, pin: t.getAttribute('data-ne-menu-link'), hasIcon: !!t.getAttribute('data-ne-icon-url') });
        }
      }
      var unusedHtml = '';
      if (unused.length) {
        var rows = unused.map(function (b) {
          var hint = b.pin ? 'Pinned to ' + b.pin + ' (no matching menu link)' : 'No menu slot left';
          return (
            '<li class="ne-icon-pairing-preview__item ne-icon-pairing-preview__item--unused">' +
              '<span class="ne-icon-pairing-preview__idx">B' + b.i + '.</span>' +
              '<span class="ne-icon-pairing-preview__label" title="' + escAttr(hint) + '">Block ' + b.i + (b.hasIcon ? '' : ' (no icon)') + '</span>' +
              '<span class="ne-icon-pairing-preview__status ne-icon-pairing-preview__status--miss">Unused</span>' +
            '</li>'
          );
        }).join('');
        unusedHtml = '<div class="ne-icon-pairing-preview__subhead">Unused blocks</div>' +
          '<ul class="ne-icon-pairing-preview__list">' + rows + '</ul>';
      }

      var summary = okCount + ' of ' + state.slots.length + ' link' + (state.slots.length === 1 ? '' : 's') + ' with icon';
      if (warnCount) summary += ' · ' + warnCount + ' missing icon';
      if (missCount) summary += ' · ' + missCount + ' without block';
      if (unused.length) summary += ' · ' + unused.length + ' unused block' + (unused.length === 1 ? '' : 's');

      var collapsed = localStorage.getItem('ne-icon-pairing-collapsed') === '1';
      root.classList.toggle('is-collapsed', collapsed);
      root.innerHTML =
        '<div class="ne-icon-pairing-preview__header">' +
          '<span class="ne-icon-pairing-preview__title">Icon nav pairing</span>' +
          '<button type="button" class="ne-icon-pairing-preview__toggle">' + (collapsed ? 'Expand' : 'Collapse') + '</button>' +
        '</div>' +
        '<div class="ne-icon-pairing-preview__summary">' + summary + '</div>' +
        '<ul class="ne-icon-pairing-preview__list">' + itemsHtml + '</ul>' +
        unusedHtml;

      var btn = root.querySelector('.ne-icon-pairing-preview__toggle');
      if (btn) {
        btn.addEventListener('click', function () {
          var nowCollapsed = !root.classList.contains('is-collapsed');
          root.classList.toggle('is-collapsed', nowCollapsed);
          btn.textContent = nowCollapsed ? 'Expand' : 'Collapse';
          localStorage.setItem('ne-icon-pairing-collapsed', nowCollapsed ? '1' : '0');
        });
      }
    }

    // Publish the header's actual bottom (viewport-relative px) to :root as
    // --ne-header-bottom. Megamenu CSS uses this instead of --ne-header-height
    // because a taller logo can make the real header exceed the configured
    // header_height value, leaving the megamenu overlapping the header.
    /* ⚠️ Jeder `setProperty` auf `documentElement` entwertet den Stil des GANZEN
       Dokuments — jede Custom Property auf `:root` kann von jedem Element geerbt
       werden (Rule 533). Im Trace vom 29.07. kostete EIN Aufruf von
       publishHeaderBottom 68,5 ms und rechnete 719 Elemente neu.
       Und beide Funktionen hingen an `scroll`, liefen also bei JEDEM Scroll-Ereignis.
       Deshalb hier ein Vergleich gegen den zuletzt geschriebenen Wert: aendert sich
       nichts, wird nichts geschrieben. Bei einem fixierten oder klebenden Header ist
       das der Normalfall, dort entfaellt der Schreibzugriff vollstaendig. */
    var _letzterHeaderBottom = null, _letzteSidebarBreite = null;

    function publishHeaderBottom() {
      var h = document.querySelector('.ne-header');
      if (!h) return;
      var rect = h.getBoundingClientRect();
      /* ⚠️ AUF GANZE PIXEL RUNDEN (29.07., zweiter Anlauf). Der Wertvergleich allein
         hat beim Scrollen nichts gebracht: im Scroll-Trace lief publishHeaderBottom
         weiterhin 91-122x und war damit der groesste Einzelposten (213-333 ms).
         Layout-Werte kommen als Bruchzahlen — `75.5999px` gegen `75.6001px` ist fuer
         den Vergleich ein neuer Wert, fuer die Darstellung derselbe. Gerundet faellt
         dieses Zittern weg und der Vergleich greift wieder.
         Verbraucher der Variable sind Megamenu-Offsets und die mobile Hero-Hoehe
         (Rule 506) — beide interessieren sich nicht fuer Zehntelpixel. */
      var wert = Math.round(Math.max(0, rect.bottom)) + 'px';
      if (wert === _letzterHeaderBottom) return;
      _letzterHeaderBottom = wert;
      document.documentElement.style.setProperty('--ne-header-bottom', wert);
    }

    // Sidebar mode: nav-items (text buttons) can be wider than the default
    // --ne-header-height. Measure the widest child column (logo/nav/actions)
    // and publish it as --ne-header-sidebar-width so the sidebar grows to
    // contain all buttons instead of letting them overflow the background.
    function publishSidebarWidth() {
      var h = document.querySelector('.ne-header');
      if (!h) return;
      var isSide = h.classList.contains('ne-header--left') || h.classList.contains('ne-header--right');
      if (!isSide) {
        if (_letzteSidebarBreite !== null) {
          _letzteSidebarBreite = null;
          document.documentElement.style.removeProperty('--ne-header-sidebar-width');
        }
        return;
      }
      var cs = getComputedStyle(h);
      var baseHeight = parseFloat(cs.getPropertyValue('--ne-header-height')) || 70;
      // Rotated (spine) nav AND radial sidebar both take the nav-links out of the
      // normal horizontal flow (vertical text / absolute arc), so measuring their
      // width is meaningless and ignores the height setting. Use the configured
      // header height as the sidebar width; the logo scales to fit (CSS max-width).
      if (h.classList.contains('ne-header--sb-spine') || h.classList.contains('ne-header--nav-arrange-radial')) {
        var wSpine = baseHeight + 'px';
        if (wSpine !== _letzteSidebarBreite) {
          _letzteSidebarBreite = wSpine;
          document.documentElement.style.setProperty('--ne-header-sidebar-width', wSpine);
        }
        return;
      }
      var padX = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
      var maxChildWidth = 0;
      var measurables = h.querySelectorAll(
        '.ne-header__nav-link, .ne-header__nav-icon-link, .ne-header__action, .ne-header__mobile-toggle, .ne-header__logo > a, .ne-header__logo img'
      );
      measurables.forEach(function (el) {
        // For logo <img>, offsetWidth reflects the current laid-out width which
        // (after the height-cap rule in sidebar mode) matches natural-aspect *
        // --ne-header-height. For buttons/links, scrollWidth captures intrinsic
        // content width even when the parent is narrower than the content.
        var w = Math.max(el.scrollWidth || 0, el.offsetWidth || 0);
        if (w > maxChildWidth) maxChildWidth = w;
      });
      var finalWidth = Math.max(baseHeight, Math.ceil(maxChildWidth + padX));
      var wert = finalWidth + 'px';
      /* Diese Breite haengt an den Kindbreiten, NICHT am Scrollstand — beim Scrollen
         aendert sie sich nie. Der Vergleich entfernt hier also jeden Schreibzugriff
         nach dem ersten. */
      if (wert === _letzteSidebarBreite) return;
      _letzteSidebarBreite = wert;
      document.documentElement.style.setProperty('--ne-header-sidebar-width', wert);
    }

    // Logo <img> reports scrollWidth/offsetWidth = 0 until the bitmap has
    // decoded. Without re-measuring post-load, publishSidebarWidth() under-
    // estimates the sidebar and the logo overflows the background. Hook all
    // header logos and re-publish once they're ready.
    function wireLogoLoadMetrics() {
      var imgs = document.querySelectorAll('.ne-header .ne-header__logo img');
      imgs.forEach(function (img) {
        if (img.__neSidebarWired) return;
        img.__neSidebarWired = true;
        if (img.complete && img.naturalWidth > 0) return;
        img.addEventListener('load', publishSidebarWidth, { once: true });
      });
    }

    // Horizontal overflow: items that don't fit a single row move into a
    // "More" dropdown appended at the end. Only runs for top/floating nav
    // (sidebar mode flows vertically and doesn't need overflow handling).
    // Measures natural item widths on each call; tolerates font / padding
    // changes from the Customizer.
    function ensureMoreItem(nav, globalMegaMode, moreMegaTemplate) {
      var existing = nav.querySelector(':scope > .ne-header__nav-item--more');
      var existingIsMega = existing && !!existing.querySelector(':scope > .ne-header__megamenu');
      // Drop the existing item if its panel shape doesn't match the current
      // mode (Customizer added/removed a megamenu_link block) OR if run()
      // flagged a rebuild because the source template content changed (e.g.
      // heading / product cards edited on the first megamenu block).
      var forceRebuild = state.moreNeedsRebuild === true;
      if (existing && (existingIsMega !== !!globalMegaMode || (globalMegaMode && forceRebuild))) {
        existing.parentNode.removeChild(existing);
        existing = null;
      }
      if (existing) return existing;
      state.moreNeedsRebuild = false;

      var more = document.createElement('div');
      more.className = 'ne-header__nav-item ne-header__nav-item--has-dropdown ne-header__nav-item--more';
      more.setAttribute('data-ne-nav-more', '');
      // Inherit the nav-button optics so "More" looks like every other nav item.
      // The --btn / --btn-<style> classes are what the real nav links carry; the
      // 3D / glass / hover effects then apply via the header modifier classes.
      var _hdr = nav.closest('.ne-header');
      var syncEl = (_hdr && _hdr.querySelector('[data-ne-header-sync]')) || document.querySelector('[data-ne-header-sync]');
      var btnStyle = (syncEl && syncEl.getAttribute('data-ne-button-style')) || 'none';
      var moreLinkCls = 'ne-header__nav-link' + (btnStyle !== 'none' ? ' ne-header__nav-link--btn ne-header__nav-link--btn-' + btnStyle : '');
      // Same colour-scheme class the real dropdowns carry, so the More panel gets
      // the same SOLID background instead of falling back to the header glass.
      var ddScheme = (syncEl && syncEl.getAttribute('data-ne-dropdown-scheme-class')) || '';
      // Button-style dropdowns render as a btn-menu (3D buttons + hover lift, no
      // glass panel). The synthetic More must use the SAME structure or it falls
      // back to a glassy ne-header__dropdown panel with plain links.
      var ddStyle = (syncEl && syncEl.getAttribute('data-ne-dropdown-style')) || 'panel';
      var showBg = (syncEl && syncEl.getAttribute('data-ne-buttons-bg')) === '1';
      var bmBtnCls = 'ne-header__btn-menu__btn' +
        (showBg ? ' ne-header__btn-menu__btn--bg' : '') +
        (showBg && btnStyle !== 'none' ? ' ne-header__nav-link--btn ne-header__nav-link--btn-' + btnStyle : '');
      var triggerHtml =
        '<a href="#" class="' + moreLinkCls + '" aria-expanded="false" aria-haspopup="true">' +
          '<span>More</span>' +
          '<svg class="ne-header__nav-chevron" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>' +
        '</a>';
      if (globalMegaMode) {
        more.classList.add('ne-header__nav-item--has-megamenu');
        more.classList.add('ne-header__nav-item--synthetic-megamenu');
        more.innerHTML = triggerHtml;
        var trigger = more.querySelector('a');
        trigger.addEventListener('click', function (e) { e.preventDefault(); });

        // Clone the first available megamenu template's panel (heading +
        // links slot + aside product cards / promo) so the More panel is
        // visually 1:1 identical to the user-configured megamenu. The links
        // slot gets emptied and refilled by applyOverflowNav with overflow
        // items; heading/aside stay intact.
        var panel;
        if (moreMegaTemplate && moreMegaTemplate.content && moreMegaTemplate.content.firstElementChild) {
          panel = moreMegaTemplate.content.firstElementChild.cloneNode(true);
          panel.classList.add('ne-header__megamenu--synthetic');
          panel.classList.add('ne-header__megamenu--more');
          var linksSlot = panel.querySelector('[data-ne-mm-links-slot]');
          if (linksSlot) {
            linksSlot.classList.add('ne-header__megamenu-links--more');
            linksSlot.setAttribute('data-ne-nav-more-slot', '');
            linksSlot.innerHTML = '';
          }
        } else {
          // Fallback: no megamenu template available (shouldn't happen in
          // globalMegaMode, but guard against race conditions).
          panel = document.createElement('div');
          panel.className = 'ne-header__megamenu ne-header__megamenu--horizon ne-header__megamenu--synthetic ne-header__megamenu--more';
          panel.setAttribute('role', 'menu');
          panel.style.setProperty('--ne-mm-cols', 1);
          panel.innerHTML =
            '<div class="ne-header__megamenu-inner">' +
              '<div class="ne-header__megamenu-links ne-header__megamenu-links--plain ne-header__megamenu-links--more" style="--ne-mm-link-cols: 1;" data-ne-mm-links-slot data-ne-nav-more-slot></div>' +
            '</div>';
        }
        more.appendChild(panel);
      } else if (ddStyle === 'buttons') {
        // Match the real button-menu dropdowns (header-dropdown-buttons.liquid):
        // container .ne-header__btn-menu (+ --bg / --shape-<style>), a column
        // <ul>, and overflow items become <li>/<a.ne-header__btn-menu__btn>.
        var bmMods = (showBg ? ' ne-header__btn-menu--bg' : '') +
          (btnStyle !== 'none' ? ' ne-header__btn-menu--shape-' + btnStyle : '');
        more.innerHTML = triggerHtml +
          '<div class="ne-header__btn-menu' + (ddScheme ? ' ' + ddScheme : '') + bmMods + '" role="menu" data-ne-btn-menu>' +
            '<ul class="ne-header__btn-menu__col" data-ne-btn-menu-col data-ne-btn-menu-depth="0" data-ne-nav-more-slot></ul>' +
          '</div>';
        var triggerB = more.querySelector('a');
        triggerB.addEventListener('click', function (e) { e.preventDefault(); });
      } else {
        more.innerHTML = triggerHtml +
          '<div class="ne-header__dropdown' + (ddScheme ? ' ' + ddScheme : '') + '" role="menu" data-ne-nav-more-slot>' +
            '<span class="ne-header__dropdown-trace" aria-hidden="true"></span>' +
          '</div>';
        var trigger2 = more.querySelector('a');
        trigger2.addEventListener('click', function (e) { e.preventDefault(); });
      }
      nav.appendChild(more);
      return more;
    }

    function applyOverflowNav(nav, globalMegaMode, moreMegaTemplate) {
      if (!nav) return;
      var header = nav.closest('.ne-header');
      if (!header) return;
      // Sidebar headers flow vertically — overflow is measured on the Y axis
      // (height) instead of the X axis (width). Radial is handled below.
      var vertical = header.classList.contains('ne-header--left') || header.classList.contains('ne-header--right');

      var more = ensureMoreItem(nav, globalMegaMode, moreMegaTemplate);
      var allItems = Array.prototype.slice.call(
        nav.querySelectorAll(':scope > .ne-header__nav-item:not(.ne-header__nav-item--more)')
      );
      if (allItems.length === 0) return;

      // Radial: items sit on an arc, not in a row, so the row-width overflow
      // must not hide any (it would drop items whose natural row width + gap
      // exceeds the flank space — that was the "missing menu item" + the gap
      // sensitivity). Show all, hide the "More" bundle; applyRadialNav places
      // them on the arc.
      if (header.classList.contains('ne-header--nav-arrange-radial')) {
        allItems.forEach(function (it) { it.style.display = ''; });
        more.style.display = 'none';
        return;
      }
      var slot = more.querySelector('[data-ne-nav-more-slot]');
      // When the dropdowns are button-menus, the More slot is a <ul> column and
      // overflow items must become <li>/<a.ne-header__btn-menu__btn> instead of
      // panel dropdown rows (so they get the 3D / hover-lift button optics).
      var slotIsBtnMenu = !!(slot && slot.tagName === 'UL');
      // Mega "More": the slot is a megamenu links container. Overflow items are
      // rebuilt as normal dropdown rows / submenus (not full nav-item clones with
      // their own panels) so More behaves exactly like any other submenu.
      var slotIsMega = !!(slot && slot.classList && slot.classList.contains('ne-header__megamenu-links'));
      var bmSync = (nav.closest('.ne-header') || document).querySelector('[data-ne-header-sync]');
      var bmShowBg = !!(bmSync && bmSync.getAttribute('data-ne-buttons-bg') === '1');
      var bmStyle = (bmSync && bmSync.getAttribute('data-ne-button-style')) || 'none';
      var bmItemBtnCls = 'ne-header__btn-menu__btn' +
        (bmShowBg ? ' ne-header__btn-menu__btn--bg' : '') +
        (bmShowBg && bmStyle !== 'none' ? ' ne-header__nav-link--btn ne-header__nav-link--btn-' + bmStyle : '');

      // Measure via offsetWidth + gap, NOT scrollWidth. scrollWidth counts
      // absolute-positioned dropdown descendants that extend past nav bounds
      // (min-width: 240px dropdowns centered on ~40px items overflow the nav
      // horizontally even when all items fit). That caused every viewport to
      // appear "overflowed" and collapse all items into More.
      // ⚠️ Diese Messung steht VOR dem Reset-Block, nicht dahinter. Die Luecke haengt
      // nicht daran, ob Eintraege sichtbar sind — hinter den Schreibzugriffen gelesen
      // kostet sie aber eine eigene erzwungene Stilneuberechnung (Rule 534). Von vier
      // erzwungenen Durchlaeufen je Aufruf bleiben so drei.
      var gap = parseFloat(getComputedStyle(nav).gap) || 0;

      // Reset: all visible, More hidden, slot empty. Truthful natural widths.
      allItems.forEach(function (it) { it.style.display = ''; });
      more.style.display = 'none';
      if (slot) {
        // Clearing the slot wipes the connector-trace span on the More panel;
        // re-add it (panel slot only — the btn-menu <ul> has no trace).
        slot.innerHTML = slotIsBtnMenu ? '' : '<span class="ne-header__dropdown-trace" aria-hidden="true"></span>';
      }


      // Available width for the nav = the real space between the logo and the
      // actions — NOT nav.clientWidth. The nav lives in the grid's `auto` middle
      // column, so its clientWidth equals its own content width → itemsWidth was
      // always <= available and overflow NEVER triggered (the nav grew straight
      // into the action icons). Measure the flanks with the items momentarily
      // hidden so the columns sit at their natural width (no overlap distortion).
      var logoEl = header.querySelector('.ne-header__logo');
      var actionsEl = header.querySelector('.ne-header__actions');
      allItems.forEach(function (it) { it.style.display = 'none'; });
      var hs = getComputedStyle(header);
      var available;
      if (vertical) {
        // Sidebar: the free VERTICAL space = sidebar height minus the logo +
        // actions zones (measured with the items hidden) minus the nav's own
        // block padding, minus a safety reserve.
        // The sidebar is an 11-row grid (header-styles ~1879): logo/nav/actions
        // sit in AUTO rows, two 1fr fillers absorb the slack. The fillers can't go
        // negative — so once logo+nav+actions exceed the container the grid
        // OVERFLOWS and the bottom-anchored action icons get clipped / shoved past
        // the edge (user 2026-07-08: icons "abhängig von Höhe / zu knapp am Rand",
        // esp. with nav-position=center). Reserving 48px (was 24) keeps both
        // fillers comfortably positive so a borderline height collapses ONE more
        // item into More BEFORE the icons can clip — sub-pixel measurement slop
        // can no longer tip it into overflow. Well-fitting heights keep the same
        // item count (they have far more slack than the extra 24px).
        var containerH = header.clientHeight - (parseFloat(hs.paddingTop) || 0) - (parseFloat(hs.paddingBottom) || 0);
        var logoH = logoEl ? logoEl.getBoundingClientRect().height : 0;
        var actionsH = actionsEl ? actionsEl.getBoundingClientRect().height : 0;
        var navCs = getComputedStyle(nav);
        var navPadY = (parseFloat(navCs.paddingTop) || 0) + (parseFloat(navCs.paddingBottom) || 0);
        available = containerH - logoH - actionsH - navPadY - 48;
      } else {
        var containerW = header.clientWidth - (parseFloat(hs.paddingLeft) || 0) - (parseFloat(hs.paddingRight) || 0);
        var logoW = logoEl ? logoEl.getBoundingClientRect().width : 0;
        var actionsW = actionsEl ? actionsEl.getBoundingClientRect().width : 0;
        var centered = !header.classList.contains('ne-header--nav-align-left') &&
          !header.classList.contains('ne-header--nav-align-right');
        var below = header.classList.contains('ne-header--nav-arrange-below');
        var logoCenter = header.classList.contains('ne-header--logo-center');
        // Below-logo nav has its own full-width row. Logo-center puts the nav in
        // one of two equal 1fr side columns (col width ≈ (container - logo)/2), so
        // its real space is that column — NOT the symmetric "container - 2*flank"
        // used for a between-flanks centered nav (that over-estimated and let
        // items overlap the centred logo). Left/right-aligned nav just clears both
        // flanks. 24px breathing room throughout.
        available = below
          ? containerW - 24
          : logoCenter
            ? (containerW - logoW) / 2 - 24
            : centered
              ? containerW - 2 * Math.max(logoW, actionsW) - 24
              : containerW - logoW - actionsW - 24;
      }
      allItems.forEach(function (it) { it.style.display = ''; });
      if (available < 0) available = 0;

      // Axis-aware size: width for a horizontal nav, height for a sidebar.
      var sizeOf = function (el) { return vertical ? el.offsetHeight : el.offsetWidth; };
      // ⚠️ Groessen HIER merken, nicht in der Ausblend-Schleife unten erneut messen.
      // Diese Schleife laeuft am Stueck ohne Schreibzugriff dazwischen, kostet also EINE
      // erzwungene Stilneuberechnung fuer alle Eintraege zusammen. Die Schleife unten
      // dagegen schreibt (`display = none`, `slot.appendChild`) und las danach erneut —
      // Lesen nach Schreiben, also eine volle Neuberechnung PRO ausgeblendetem Eintrag.
      // Im Trace vom 2026-07-29 war das mit 25 erzwungenen Durchlaeufen der groesste
      // Einzelposten der Stilneuberechnung ueberhaupt (Rule 534).
      // Der gemerkte Wert ist derselbe, den die Schleife unten gebraucht haette: die
      // Rechnung dort zieht `sizes[i]` von `itemsWidth` ab, und `itemsWidth` ist aus
      // genau diesen Werten summiert. Frisch zu messen waere sogar inkonsistent —
      // eine vorberechnete Summe mit Live-Messungen zu mischen setzt ohnehin voraus,
      // dass sich die Einzelgroessen nicht aendern.
      var sizes = new Array(allItems.length);
      var itemsWidth = 0;
      for (var k = 0; k < allItems.length; k++) {
        sizes[k] = sizeOf(allItems[k]);
        itemsWidth += sizes[k];
        if (k > 0) itemsWidth += gap;
      }

      // Fits without More — done.
      if (itemsWidth <= available + 1) return;

      // Doesn't fit. Show More, measure its width (now that it's in layout),
      // then hide items from the end until remainder + More fits.
      more.style.display = '';
      var moreWidth = sizeOf(more) + gap;
      var current = itemsWidth + moreWidth;
      for (var i = allItems.length - 1; i >= 0; i--) {
        if (current <= available + 1) break;
        var item = allItems[i];
        current -= (sizes[i] + gap);   // gemerkt statt neu gemessen — siehe oben
        item.style.display = 'none';
        if (!slot) continue;

        // Clone the FULL item (link + any nested .ne-header__dropdown or
        // .ne-header__megamenu panel) so megamenu / submenu items keep
        // their panels in the More dropdown. CSS :hover cascades continue to
        // work on the clone; megamenu panels are position: fixed viewport-
        // centered so they render correctly regardless of DOM location.
        // Fallback for simple links: a plain dropdown-link row.
        var hasChildPanel = item.querySelector(':scope > .ne-header__dropdown, :scope > .ne-header__megamenu')
          || item.classList.contains('ne-header__nav-item--has-megamenu');
        var entry;
        var a = item.querySelector('a[href]');
        var title = item.getAttribute('data-ne-nav-title') || (a ? a.textContent : '');
        var url = item.getAttribute('data-ne-nav-url') || (a ? a.getAttribute('href') : '#');
        if (slotIsBtnMenu) {
          // Button-menu column → a real btn-menu item (gets 3D + hover-lift).
          entry = document.createElement('li');
          entry.className = 'ne-header__btn-menu__item';
          var blink = document.createElement('a');
          blink.href = url;
          blink.className = bmItemBtnCls;
          blink.setAttribute('role', 'menuitem');
          var blabel = document.createElement('span');
          blabel.className = 'ne-header__btn-menu__label';
          blabel.textContent = title;
          blink.appendChild(blabel);
          entry.appendChild(blink);
          // Preserve a button-menu submenu so an overflowed item that has its
          // own sub-items stays EXPANDABLE inside "More" (clone the source
          // column as a nested sub-column; deeper nesting rides along in clone).
          var srcBtnCol = item.querySelector(':scope > .ne-header__btn-menu > .ne-header__btn-menu__col');
          if (srcBtnCol) {
            entry.classList.add('ne-header__btn-menu__item--has-submenu');
            blink.setAttribute('aria-haspopup', 'true');
            blink.setAttribute('aria-expanded', 'false');
            blink.insertAdjacentHTML('beforeend', '<svg class="ne-header__btn-menu__chevron" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>');
            var subCol = srcBtnCol.cloneNode(true);
            subCol.classList.add('ne-header__btn-menu__col--sub');
            subCol.setAttribute('data-ne-btn-menu-depth', '1');
            entry.appendChild(subCol);
          }
        } else if (slotIsMega) {
          // Mega More → a normal dropdown row / submenu (transformSubmenus below
          // turns has-submenu rows into the merchant's chosen columns/flyout/
          // accordion), NOT a nested nav-item clone with its own mega panel.
          entry = buildMoreItem(item);
        } else if (hasChildPanel) {
          // Clone the FULL nav-item (link + its dropdown/megamenu) so the
          // submenu + trace render exactly as in the nav. The font / animation
          // differences this used to cause are corrected in CSS (see the
          // .ne-header__nav-item--more-child rules in header-styles.liquid),
          // which is far less fragile than rebuilding the nested structure.
          entry = item.cloneNode(true);
          entry.style.display = '';
          entry.classList.add('ne-header__nav-item--more-child');
        } else {
          entry = document.createElement('div');
          entry.className = 'ne-header__dropdown-item';
          var link = document.createElement('a');
          link.href = url;
          link.className = 'ne-header__dropdown-link';
          link.setAttribute('role', 'menuitem');
          link.textContent = title;
          entry.appendChild(link);
        }
        // Prepend so the dropdown preserves source order.
        slot.insertBefore(entry, slot.firstChild);
      }

      // Mega More: apply the same submenu model as the rest of the mega system,
      // and size the columns to the number of submenu groups (like a normal mega).
      if (slotIsMega && slot) {
        var _trM = slot.querySelector(':scope > .ne-header__dropdown-trace');
        if (_trM) _trM.remove();
        var _mmSubMore = getMmSub(nav);
        transformSubmenus(slot, _mmSubMore);
        var _mg = slot.querySelectorAll(':scope > .ne-header__megamenu-group').length;
        slot.style.setProperty('--ne-mm-link-cols', (_mmSubMore === 'columns' && _mg >= 1) ? Math.min(3, _mg) : 1);
      }

      // Stagger index for the btn-menu cascade reveal. The open animation
      // (@keyframes ne-btn-menu-item-in) reads --i for its per-button delay
      // (calc(var(--i,0) * speed)). Server-rendered btn-menu buttons get --i
      // from Liquid, and the More's cloned SUB-columns keep theirs (cloneNode),
      // but the JS-built More TOP-LEVEL buttons had no --i → all animated with
      // delay 0 (appeared simultaneously) while the regular dropdowns + the
      // More's own submenu staggered (user 2026-06-24). Assign --i top-to-bottom
      // over the final, source-ordered slot buttons so the More cascades too.
      if (slotIsBtnMenu && slot) {
        var topBtns = slot.querySelectorAll(':scope > .ne-header__btn-menu__item > .ne-header__btn-menu__btn');
        for (var ti = 0; ti < topBtns.length; ti++) {
          topBtns[ti].style.setProperty('--i', ti);
        }
      }

      // Cols config stays as rendered by the source megamenu template —
      // User explicitly set it on the first megamenu block, so More inherits
      // that value 1:1 (no runtime rescaling).
    }

    // Button-menu viewport-flip: when the root panel's right edge would
    // overflow the viewport, flip the whole cascade to the left (left:auto;
    // right:0). Sub-columns follow via CSS (--flip-left scoped rule).
    // Measured on every hover-open so layout changes (resize, Customizer
    // edits) pick up automatically. Sub-columns are repositioned per-open
    // too so deeper cascades also respect the viewport bounds.
    function initBtnMenuFlip(navRoot) {
      if (!navRoot) return;
      var roots = Array.prototype.slice.call(navRoot.querySelectorAll('[data-ne-btn-menu]'));
      roots.forEach(function (menu) {
        var host = menu.closest('.ne-header__nav-item');
        if (!host || host.__neBtnMenuFlipBound) return;
        host.__neBtnMenuFlipBound = true;
        var check = function () {
          // Clear flip so we measure the default-right placement.
          menu.classList.remove('ne-header__btn-menu--flip-left');
          // rAF so CSS open-transition has placed the panel.
          requestAnimationFrame(function () {
            var r = menu.getBoundingClientRect();
            var pad = 8;
            if (r.right > window.innerWidth - pad) {
              menu.classList.add('ne-header__btn-menu--flip-left');
            }
          });
        };
        host.addEventListener('mouseenter', check);
        host.addEventListener('focusin', check);
      });

      // Sub-columns: per-level flip when their right edge would overflow.
      // Listener is attached once per item; re-enter re-measures.
      var subItems = Array.prototype.slice.call(navRoot.querySelectorAll('.ne-header__btn-menu__item--has-submenu'));
      subItems.forEach(function (item) {
        if (item.__neBtnMenuSubFlipBound) return;
        item.__neBtnMenuSubFlipBound = true;
        var sub = item.querySelector(':scope > .ne-header__btn-menu__col--sub');
        if (!sub) return;
        var check = function () {
          sub.classList.remove('ne-header__btn-menu__col--flip-left', 'ne-header__btn-menu__col--up', 'ne-header__btn-menu__col--cap');
          sub.style.removeProperty('--ne-bm-col-maxh');
          requestAnimationFrame(function () {
            var r = sub.getBoundingClientRect();
            var ir = item.getBoundingClientRect();
            var fh = sub.offsetHeight;
            var pad = 8;
            var vw = window.innerWidth || document.documentElement.clientWidth;
            var vh = window.innerHeight || document.documentElement.clientHeight;
            // Horizontal: flip the sub-column left when it overflows the right.
            if (r.right > vw - pad) sub.classList.add('ne-header__btn-menu__col--flip-left');
            // Vertical: follow the panel's open direction (open-up → prefer up,
            // mirroring applyFlyoutFlip), else prefer down. Fall back to the
            // other side / cap + scroll. Keeps the btn-menu sub-column
            // consistent with the root when the header sits low (user #14).
            var hdr = item.closest('.ne-header');
            var preferUp = hdr && hdr.classList.contains('ne-header--open-up');
            var spaceDown = vh - pad - ir.top;
            var spaceUp = ir.bottom - pad;
            var first = preferUp ? spaceUp : spaceDown;
            var second = preferUp ? spaceDown : spaceUp;
            if (fh <= first) {
              if (preferUp) sub.classList.add('ne-header__btn-menu__col--up');
              /* else default down */
            } else if (fh <= second) {
              if (!preferUp) sub.classList.add('ne-header__btn-menu__col--up');
              /* else default down */
            } else if (first >= second) {
              if (preferUp) sub.classList.add('ne-header__btn-menu__col--up');
              sub.classList.add('ne-header__btn-menu__col--cap');
              sub.style.setProperty('--ne-bm-col-maxh', Math.max(160, first) + 'px');
            } else {
              if (!preferUp) sub.classList.add('ne-header__btn-menu__col--up');
              sub.classList.add('ne-header__btn-menu__col--cap');
              sub.style.setProperty('--ne-bm-col-maxh', Math.max(160, second) + 'px');
            }
          });
        };
        item.addEventListener('mouseenter', check);
        item.addEventListener('focusin', check);
      });
    }

    // Panel-mode "More" child flyout viewport positioning. A more-child is a
    // cloned nav-item whose dropdown/megamenu opens to the SIDE (left:100%,
    // top:0). With no viewport awareness it clipped off the right edge and the
    // bottom (user 2026-06-23). On hover, measure the flyout and flip it:
    //   • left  — when the right edge would overflow the viewport
    //   • up    — when opening down would clip the bottom but up fits
    //   • cap   — when it fits neither way: anchor the larger side + scroll
    // Mirrors initBtnMenuFlip's clear→rAF→measure pattern. Re-bound each
    // overflow pass because more-children are re-cloned (fresh DOM, no guard).
    // Shared side-flyout positioner: measure the flyout, then flip left / up /
    // cap so it never clips the viewport. `gap` = the horizontal offset between
    // the trigger's edge and the flyout (8px for More children, ~22px for
    // submenus). Clears classes first (like initBtnMenuFlip) so the rAF measures
    // the intrinsic, default-placed size.
    function applyFlyoutFlip(item, fly, gap) {
      item.classList.remove('is-flyout-left', 'is-flyout-up', 'is-flyout-cap');
      fly.style.removeProperty('--ne-more-flyout-maxh');
      requestAnimationFrame(function () {
        var ir = item.getBoundingClientRect();
        var fw = fly.offsetWidth, fh = fly.offsetHeight;
        var vw = window.innerWidth || document.documentElement.clientWidth;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var pad = 8;
        // Horizontal: flip left if right placement overflows.
        if (ir.right + gap + fw > vw - pad) item.classList.add('is-flyout-left');
        // Vertical: follow the panel's open direction. When the header sits low
        // (open-up), the parent panel opens upward — so prefer UP for the flyout
        // too (consistent + doesn't cross the low header, user 2026-06-23).
        // Otherwise prefer down. Fall back to the other side / cap when needed.
        var hdr = item.closest('.ne-header');
        var preferUp = hdr && hdr.classList.contains('ne-header--open-up');
        var spaceDown = vh - pad - ir.top;
        var spaceUp = ir.bottom - pad;
        var first = preferUp ? spaceUp : spaceDown;
        var second = preferUp ? spaceDown : spaceUp;
        if (fh <= first) {
          if (preferUp) item.classList.add('is-flyout-up');
          /* else default down */
        } else if (fh <= second) {
          if (!preferUp) item.classList.add('is-flyout-up');
          /* else default down */
        } else if (first >= second) {
          if (preferUp) item.classList.add('is-flyout-up');
          item.classList.add('is-flyout-cap');
          fly.style.setProperty('--ne-more-flyout-maxh', Math.max(160, first) + 'px');
        } else {
          if (!preferUp) item.classList.add('is-flyout-up');
          item.classList.add('is-flyout-cap');
          fly.style.setProperty('--ne-more-flyout-maxh', Math.max(160, second) + 'px');
        }
      });
    }

    function bindFlyout(item, fly, gap) {
      var position = function () { applyFlyoutFlip(item, fly, gap); };
      item.addEventListener('mouseenter', position);
      item.addEventListener('focusin', position);
    }

    // Sidebar More-child flyout: the base left:100% side-flyout resolved unreliably inside the fixed,
    // narrow sidebar More panel (measured landing MID-panel → overlap, user 2026-07-08). Position it
    // DETERMINISTICALLY off the More panel's measured rect: fixed, just past the panel's outer edge,
    // bottom-aligned with the panel's END (the item sits low). Escapes the panel + is glued to it.
    function bindSbMoreFlyout(item, fly, hdr) {
      var work = function () {
          var isRight = hdr.classList.contains('ne-header--right');
          var isSidebar = isRight || hdr.classList.contains('ne-header--left');
          var panel = item.closest('.ne-header__megamenu, .ne-header__dropdown'); // the parent panel (ancestor)
          if (!panel) return;
          var pr = panel.getBoundingClientRect();
          var ir = item.getBoundingClientRect();   // the item is position:relative → the flyout's containing block
          var vw = window.innerWidth || document.documentElement.clientWidth;
          var vh = window.innerHeight || document.documentElement.clientHeight;
          var gap = 8, pad = 8;
          var fh = fly.offsetHeight, fw = fly.offsetWidth;
          // Frame-aware vertical bounds: a tall flyout must stay inside the decorative FRAME's inner
          // edge, not just the viewport, or its bottom crosses the frame (user 2026-07-08). Same
          // clearance formula as the merge panel positioner (menu.liquid:2424/2426): frame offset +
          // padding + 2× corner radius so rounded corners clear the frame's rounded corners.
          var cs = getComputedStyle(hdr);
          var pxv = function (name, dflt) { var v = parseFloat(cs.getPropertyValue(name)); return isNaN(v) ? dflt : v; };
          var mergeR = pxv('--ne-merge-r', 0);
          // Vertical clearance to the frame's inner edge = the same `gap` used between the panels (user
          // 2026-07-08 wanted the bottom gap to match the inter-panel gap, not the larger corner clearance).
          var topBound = Math.max(pad, pxv('--ne-frame-offset', 8) + pxv('--ne-frame-padding-top', 0) + gap);
          var botBound = vh - Math.max(pad, pxv('--ne-frame-offset', 8) + pxv('--ne-frame-padding-bottom', 0) + gap);
          var leftBound = Math.max(pad, pxv('--ne-frame-offset', 8) + pxv('--ne-frame-padding-left', 0) + mergeR * 2);
          var rightBound = vw - Math.max(pad, pxv('--ne-frame-offset', 8) + pxv('--ne-frame-padding-right', 0) + mergeR * 2);
          // Side selection. Sidebar seam is authoritative. Nested flyouts (parent panel is itself a
          // placed side-flyout) INHERIT the parent's side so the chain flows AWAY from the origin panel
          // instead of folding back over it (user 2026-07-08: the deepest More submenu independently
          // chose the right side and overlapped the More panel). Otherwise (top-level parent, e.g. the
          // More dropdown): prefer right, flip left when the right side would overflow the viewport.
          // Room available beside the panel up to each FRAME inner edge (not just the viewport) — a deep
          // chain near the burger breakpoint must fit between the origin panel and the frame (user
          // 2026-07-08, image #30: child collided with the frame AND the parent panel).
          var roomRight = rightBound - (pr.right + gap);
          var roomLeft = (pr.left - gap) - leftBound;
          var placeLeft;
          if (isSidebar) {
            placeLeft = isRight;
          } else if (panel.classList.contains('ne-mc-placed-left')) {
            placeLeft = true;   // nested: inherit the parent's side (chain flows away from the origin)
          } else if (panel.classList.contains('ne-mc-placed-right')) {
            placeLeft = false;
          } else {
            placeLeft = (roomRight < fw) && (roomLeft > roomRight);  // prefer right; flip left if it fits better
          }
          // Dynamic width: if the flyout doesn't fit in the room between its parent panel and the frame,
          // CAP it to exactly that room (override the base min-width:240 so it can shrink) — the nowrap
          // links truncate with an ellipsis (header-styles 2609/2615). This is what keeps a DEEP chain in
          // a narrow window from overlapping its parent (user 2026-07-08, image #31: a 3rd level had only
          // 77px of room → capping it to 77 sits it flush beside the parent instead of clamped over it).
          // Absolute floor 72px (≈ one word) below which it's unusable anyway (basically at the burger
          // breakpoint); a sub-72 room then keeps a tiny overlap rather than a 0-width sliver.
          var room = Math.max(0, placeLeft ? roomLeft : roomRight);
          if (fw > room) {
            fly.style.setProperty('max-width', Math.max(72, Math.floor(room)) + 'px', 'important');
            fly.style.setProperty('min-width', '0px', 'important');
            fw = fly.offsetWidth;   // re-measure after the cap
          } else {
            fly.style.removeProperty('max-width');
            fly.style.removeProperty('min-width');
          }
          // Just past the panel's OUTER edge (beside the whole panel, no overlap).
          var targetLeft = placeLeft ? (pr.left - gap - fw) : (pr.right + gap);
          // Clamp horizontally to the FRAME inner edges WITHOUT folding back over the ancestor chain.
          if (targetLeft + fw > rightBound) targetLeft = rightBound - fw;
          if (targetLeft < leftBound) targetLeft = leftBound;
          // Vertical: align the flyout's TOP with the ITEM's top so it opens ON THE ITEM'S ROW — the
          // flyout MUST vertically overlap its parent item, else the cursor has to move diagonally off
          // the item to reach it and triggers a sibling on the way (user 2026-07-08, "Contact" child
          // was unreachable when bottom-aligned to the panel). Clamp into the viewport for tall menus;
          // the item stays inside the clamped range so the horizontal hop stays on the (full-width) item.
          var targetTop = ir.top;
          if (targetTop + fh > botBound) targetTop = botBound - fh;
          if (targetTop < topBound) targetTop = topBound;
          // Widen the hover-bridge to span the gap the cursor crosses (item's edge → flyout), so
          // moving from the full-width item to the detached flyout never drops the hover.
          // Generous overlap so the cursor keeps hover crossing the gap (both sides felt fiddly, user
          // 2026-07-08; still dropped on the button-optik panels, user 2026-07-09): span the physical
          // gap PLUS ~44px of overlap onto the item's row, floor 56px.
          var bridge = (placeLeft ? (ir.left - (targetLeft + fw)) : (targetLeft - ir.right)) + 44;
          fly.style.setProperty('--ne-mc-bridge', Math.max(56, bridge) + 'px');
          // Publish the PLACED side as a class so the bridge ::before lands on the correct edge in the
          // top header (dynamic flip). The sidebar keys its bridge off the header class instead, so
          // these classes are harmless there. (user 2026-07-08)
          fly.classList.toggle('ne-mc-placed-left', placeLeft);
          fly.classList.toggle('ne-mc-placed-right', !placeLeft);
          // Convert to the item's LOCAL coords (position:absolute is measured from the item, which is
          // the nearest positioned ancestor = the containing block — robust even if a merge transform
          // on the parent panel would break position:fixed). Inline !important beats the base left:100%.
          fly.style.setProperty('left', (targetLeft - ir.left) + 'px', 'important');
          fly.style.setProperty('top', (targetTop - ir.top) + 'px', 'important');
          fly.style.setProperty('max-height', (botBound - topBound) + 'px', 'important');
      };
      // Expose the positioner so the inline accordion can re-clamp this flyout as it grows/shrinks.
      var reposition = function () { requestAnimationFrame(work); };
      fly.__neReposition = work;
      item.addEventListener('mouseenter', reposition);
      item.addEventListener('focusin', reposition);
    }

    function initMoreFlyoutFlip(nav) {
      if (!nav) return;
      var hdr = nav.closest('.ne-header');
      var isSidebar = hdr && (hdr.classList.contains('ne-header--left') || hdr.classList.contains('ne-header--right'));
      // Top header in MERGE mode uses the SAME deterministic side-flyout as the sidebar (open beside the
      // parent panel on the item's row, all-corner radius, matched gap) so both modes look identical
      // (user 2026-07-08). Non-merge top headers keep the class-based flip. bindSbMoreFlyout auto-flips
      // left when the right side would overflow (More sits at the header's right edge).
      var useSideFlyout = isSidebar || (hdr && hdr.classList.contains('ne-header--menu-merge'));
      var children = Array.prototype.slice.call(nav.querySelectorAll('.ne-header__nav-item--more-child'));
      children.forEach(function (item) {
        if (item.__neMoreFlyoutBound) return;
        item.__neMoreFlyoutBound = true;
        var fly = item.querySelector(':scope > .ne-header__dropdown:not(.ne-header__dropdown--mega)') ||
                  item.querySelector(':scope > .ne-header__megamenu');
        if (!fly) return;
        if (useSideFlyout) { bindSbMoreFlyout(item, fly, hdr); return; }
        bindFlyout(item, fly, 8);
      });
    }

    // Normal cascading submenus (dropdown-item > dropdown--submenu) open to the
    // side too and clipped the viewport near the right/bottom edge just like the
    // More flyout (user 2026-06-23). Same flip logic; gap = the submenu's
    // horizontal offset (space-3 + dropdown-gap ≈ 22px). Covers submenus inside
    // "More" too (they're dropdown-item--has-submenu in the clone).
    function initSubmenuFlip(scope) {
      if (!scope) return;
      var hdr = scope.closest('.ne-header');
      var isSidebar = hdr && (hdr.classList.contains('ne-header--left') || hdr.classList.contains('ne-header--right'));
      // Merge mode (sidebar OR top): same item-row side-flyout treatment as the More children (open
      // beside the parent panel, matched 8px gap, all-corner radius) so cascading submenus match the
      // More optics + stay reachable. Non-merge headers keep the base flip. (user 2026-07-08)
      var useSideFlyout = isSidebar || (hdr && hdr.classList.contains('ne-header--menu-merge'));
      var items = Array.prototype.slice.call(scope.querySelectorAll('.ne-header__dropdown-item--has-submenu'));
      items.forEach(function (item) {
        if (item.__neSubFlyoutBound) return;
        item.__neSubFlyoutBound = true;
        var fly = item.querySelector(':scope > .ne-header__dropdown--submenu');
        if (!fly) return;
        // DEEPEST level INSIDE the "More" overflow menu → inline CLICK-accordion instead of a 3rd side
        // panel. More adds an extra nesting level to Shopify's 2-level menu; three side panels can't fit
        // side-by-side in a narrow window (user 2026-07-08, chose click + deepest-level-only). The sub
        // rows expand in-flow + indented so the parent flyout just grows. Only when the has-submenu row
        // sits inside a More child (its first-level flyout stays a side panel).
        if (item.closest('.ne-header__nav-item--more-child')) {
          item.classList.add('ne-sub-inline');
          fly.style.maxHeight = '0px';   // start COLLAPSED — inline beats any CSS max-height so both
                                         // rows are shut on open, not pre-expanded (user 2026-07-08)
          var trigger = item.querySelector(':scope > .ne-header__dropdown-link');
          if (trigger) {
            trigger.setAttribute('aria-expanded', 'false');
            trigger.addEventListener('click', function (e) {
              e.preventDefault();
              e.stopPropagation();
              var open = !item.classList.contains('ne-sub-expanded');
              item.classList.toggle('ne-sub-expanded', open);
              trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
              // Exact target height for a smooth open; scrollHeight is the full content even while
              // collapsed (overflow:hidden retains it). 0 collapses.
              fly.style.maxHeight = open ? (fly.scrollHeight + 'px') : '0px';
              // The parent side-flyout just grew/shrank → re-clamp it EACH FRAME during the 260ms
              // max-height animation so its bottom stays inside the frame: it grows DOWN until the
              // bottom clearance is reached, then the top rides UP (bindSbMoreFlyout's botBound clamp).
              // (user 2026-07-08 — sidebar flyout ran off-screen on expand)
              var parentFlyout = item.closest('.ne-header__megamenu, .ne-header__dropdown');
              if (parentFlyout && parentFlyout.__neReposition) {
                var frames = 0;
                var tick = function () {
                  parentFlyout.__neReposition();
                  if (++frames < 20) requestAnimationFrame(tick);
                };
                requestAnimationFrame(tick);
              }
            });
          }
          return;
        }
        if (useSideFlyout) { bindSbMoreFlyout(item, fly, hdr); return; }
        bindFlyout(item, fly, 22);
      });
    }

    // TOP header merge — the weld bracket (nav-item ::before) needs the panel's REAL top corners.
    // Full-width megamenus are viewport-centred (the base `50% − panel-w/2` formula is exact), but a
    // plain DROPDOWN is centred under its TRIGGER (off-centre) → the formula lands the fillets at the
    // megamenu's corners, not the narrow panel's (user 2026-07-08: "Radien zwischen Panel und Header
    // fehlen"). Publish the dropdown's measured edges as --ne-dd-bracket-left/right (relative to the
    // fixed bracket's CONTAINING BLOCK — the viewport, or the nearest transformed ancestor in
    // frame-mouth mode) on hover; the CSS reads them with the centred formula as fallback (megamenus,
    // pre-hover). X is stable (only Y slides on open) so measuring pre-open is fine.
    function initTopMergeBrackets(nav) {
      if (!nav) return;
      var hdr = nav.closest('.ne-header');
      if (!hdr || !hdr.classList.contains('ne-header--top') || !hdr.classList.contains('ne-header--menu-merge')) return;
      var items = Array.prototype.slice.call(nav.querySelectorAll('.ne-header__nav-item:not(.ne-header__nav-item--more-child)'));
      items.forEach(function (item) {
        if (item.__neTopBracketBound) return;
        var panel = item.querySelector(':scope > .ne-header__dropdown:not(.ne-header__dropdown--mega)');
        if (!panel) return;   // full-width megamenus stay on the centred fallback formula
        item.__neTopBracketBound = true;
        var measure = function () {
          requestAnimationFrame(function () {
            var pr = panel.getBoundingClientRect();
            var vw = window.innerWidth || document.documentElement.clientWidth;
            // The fixed bracket resolves against the nearest transform/filter/perspective ancestor
            // (frame-mouth) or the viewport. Measure the panel relative to THAT same box so the value
            // is correct in both modes.
            var cbLeft = 0, cbRight = vw, node = item.parentElement;
            while (node && node !== document.body && node !== document.documentElement) {
              var cs = getComputedStyle(node);
              if (cs.transform !== 'none' || cs.perspective !== 'none' || cs.filter !== 'none') {
                var cr = node.getBoundingClientRect(); cbLeft = cr.left; cbRight = cr.right; break;
              }
              node = node.parentElement;
            }
            // Integer-snap + 1px overlap INTO the panel: the panel paints on a fractional boundary
            // (measured pr.left ≈ 769.92) and the fillet tile snapped independently → a 1px seam
            // between fillet and panel side (user 2026-07-08, same sub-pixel issue as the sidebar
            // bracket). Round both edges and tuck the fillets 1px under the panel to close it.
            item.style.setProperty('--ne-dd-bracket-left', (Math.round(pr.left - cbLeft) + 1) + 'px');
            item.style.setProperty('--ne-dd-bracket-right', (Math.round(cbRight - pr.right) + 1) + 'px');
          });
        };
        item.addEventListener('mouseenter', measure);
        item.addEventListener('focusin', measure);
      });
    }

    // Radial arrangement: position the visible nav items on an arc around the
    // logo. Runs AFTER applyOverflowNav so it places the items the overflow
    // pass left visible (incl. the "More" item). First stand: half-circle for
    // a centred logo (sides at logo height, middle at the bottom), quarter for
    // a side logo. Items stay horizontal. Open-up flips the arc upward.
    function applyRadialNav(nav) {
      var header = nav.closest('.ne-header');
      if (!header) return;
      // Don't measure/re-place while the nav is transform-hidden by the scroll
      // reveal (scale/collapse shrink it): getBoundingClientRect would read the
      // SHRUNKEN nav and freeze every point at a corrupt spot when the class
      // observer fires mid-animation (the "nav sticks at the top" bug — user
      // 2026-07-11). It re-runs cleanly once the nav is shown again.
      if (header.classList.contains('ne-header--nav-scrolling')) return;
      var items = Array.prototype.slice.call(nav.querySelectorAll('.ne-header__nav-item'));
      if (!header.classList.contains('ne-header--nav-arrange-radial')) {
        items.forEach(function (it) { it.style.left = ''; it.style.top = ''; it.removeAttribute('data-radial-side'); });
        header.style.removeProperty('--ne-radial-reserve');
        return;
      }
      var visible = items.filter(function (it) { return it.style.display !== 'none'; });
      var n = visible.length;
      if (!n) return;
      // Sunburst orientation (opt-in): rotate each pill ALONG its ray to the logo
      // ("wie die Strahlen einer Sonne", user 2026-07-11). Only the .nav-link (pill)
      // rotates via --ne-radial-rot — the item frame stays unrotated so its dropdown
      // still opens beside/horizontal (Rule 458). Back-facing pills flip 180° so the
      // label never reads upside-down.
      var _sunburst = header.classList.contains('ne-header--radial-sunburst');
      // Top-centred fan disables the tilt cap: its rays run near-vertical (points sit
      // straight below the logo), so the middle point should stand FULLY at 90° pointing
      // at the logo, not lean at the 80° cap (user 2026-07-12). Set in the centred branch.
      var _noTiltCap = false;
      var _setRot = function (item, ox, oy) {
        if (!_sunburst) { item.style.removeProperty('--ne-radial-rot'); return; }
        var a = Math.atan2(oy, ox);
        // Normalise into the readable half [-90°, 90°] so a label never reads
        // upside-down (back-facing rays fold onto their front-facing mirror).
        if (a > Math.PI / 2) a -= Math.PI;
        else if (a < -Math.PI / 2) a += Math.PI;
        // Cap the tilt so the FIRST/LAST points (ray ≈ ±90°) never stand FULLY
        // vertical, but let them lean HARD toward the logo (user 2026-07-12 wanted the
        // steep ends to point more at the logo — a truer ray — accepting less-readable
        // near-vertical labels there). Middle points keep their exact ray (|a| < maxTilt).
        var maxTilt = _noTiltCap ? (Math.PI / 2) : 1.40;    // 90° (top-centred) else ~80°
        if (a > maxTilt) a = maxTilt; else if (a < -maxTilt) a = -maxTilt;
        item.style.setProperty('--ne-radial-rot', a.toFixed(4) + 'rad');
      };
      var nRect = nav.getBoundingClientRect();
      var cx = nRect.width / 2, cy = nRect.height / 2;
      var aspect = 1.8;
      // Pick the VISIBLE main-bar logo — a header can carry a second .ne-header__logo
      // in the burger drawer / mobile menu that querySelector would return first,
      // landing the arc + the collapse origin on the wrong spot (user 2026-07-11).
      // Exclude drawer/mobile copies and anything not actually laid out (offsetParent
      // null = display:none somewhere up the tree), then take the visible one.
      var logo = Array.prototype.slice.call(header.querySelectorAll('.ne-header__logo'))
        .filter(function (l) {
          if (l.closest('.ne-mobile-menu, .ne-header__drawer, [data-ne-drawer], .ne-header__burger')) return false;
          if (l.offsetParent === null && getComputedStyle(l).position !== 'fixed') return false;
          var r = l.getBoundingClientRect();
          return r.width > 0 && r.height > 0;
        })[0]
        || header.querySelector('.ne-header__logo');
      if (logo) {
        var lRect = logo.getBoundingClientRect();
        // Items are absolutely positioned inside the nav, so their containing
        // block is the NAV box, not the header. Compute the logo centre
        // relative to the nav so the arc lands around the real logo wherever
        // the nav's grid cell sits (fixes the side-logo offset — items were
        // landing ~960px off near the action icons).
        cx = lRect.left + lRect.width / 2 - nRect.left;
        cy = lRect.top + lRect.height / 2 - nRect.top;
        if (lRect.width > 0 && lRect.height > 0) aspect = lRect.width / lRect.height;
      }
      // Manual centre offset (user 2026-07-11): nudge the whole arc/fan closer to
      // or away from the logo. Shifts every point uniformly; the arc-shape
      // decisions (logoFrac quarter/half) still read the TRUE logo position via
      // logoCy so a small nudge doesn't flip the layout mode.
      var logoCx = cx, logoCy = cy;
      cx += parseFloat(getComputedStyle(header).getPropertyValue('--ne-radial-offset-x')) || 0;
      cy += parseFloat(getComputedStyle(header).getPropertyValue('--ne-radial-offset-y')) || 0;
      // Manual angular spacing (sunburst): degrees BETWEEN neighbouring rays,
      // measured from the 0° ray (horizontal for a side header). 0 = auto-fan.
      var stepRad = (parseFloat(getComputedStyle(header).getPropertyValue('--ne-radial-angle-step')) || 0) * Math.PI / 180;
      // Whole-fan rotation (sunburst): spins the entire ring of points around the
      // logo. 0 = the middle point sits horizontal; ±rotates the fan up/down.
      var rotRad = (parseFloat(getComputedStyle(header).getPropertyValue('--ne-radial-rotate')) || 0) * Math.PI / 180;
      // Elliptical arc — wider than tall, aspect follows the logo format (a
      // long logo -> wide flat ellipse, a square logo -> near-circle). The base
      // size comes from the radial radius setting; rx/ry split keeps the area
      // roughly constant while the shape tracks the logo.
      var base = parseFloat(getComputedStyle(header).getPropertyValue('--ne-radial-radius')) || 120;
      // Vertical spread (%) scales the arc HEIGHT independently of the radius,
      // so merchants can open up the row gaps (and fill the centre void on an
      // even item count) without making the whole arc wider.
      var vspread = (parseFloat(getComputedStyle(header).getPropertyValue('--ne-radial-vspread')) || 100) / 100;
      aspect = Math.min(Math.max(aspect, 1), 3.2);
      var rx = base * Math.sqrt(aspect);
      var ry = (base / Math.sqrt(aspect)) * vspread;
      var openUp = header.classList.contains('ne-header--open-up');
      var ySign = openUp ? -1 : 1;                          // arc bulges up (open-up) or down
      var logoLeft = header.classList.contains('ne-header--logo-left');
      var logoRight = header.classList.contains('ne-header--logo-right');
      var sidebarLeft = header.classList.contains('ne-header--left');
      var sidebarRight = header.classList.contains('ne-header--right');

      // Distribution mode (merchant setting):
      //   'auto'  → per-layout default (centred = arc, side/sidebar = rows)
      //   'arc'   → even spacing ALONG the curve length (Bogenmaß)
      //   'rows'  → even spacing in the primary stacking axis (Zeilenabstände):
      //             vertical for side-logo/sidebar arcs, horizontal for the
      //             centred half-arc.
      var dist = (getComputedStyle(header).getPropertyValue('--ne-radial-dist') || 'auto').trim() || 'auto';
      // Resample a parametric offset curve to even arc-length. point(u) returns
      // {x, y} for u in [0,1]; returns n points at equal length fractions.
      function evenArc(point, count, samp) {
        samp = samp || 200;
        var pts = [], tot = 0, prev = null, s, p;
        for (s = 0; s <= samp; s++) {
          p = point(s / samp);
          if (prev) tot += Math.sqrt((p.x - prev.x) * (p.x - prev.x) + (p.y - prev.y) * (p.y - prev.y));
          pts.push({ x: p.x, y: p.y, l: tot });
          prev = p;
        }
        var out = [], i, k;
        for (i = 0; i < count; i++) {
          var target = count === 1 ? tot / 2 : (i / (count - 1)) * tot;
          var hit = pts[pts.length - 1];
          for (k = 1; k < pts.length; k++) {
            if (pts[k].l >= target) {
              var a = pts[k - 1], b = pts[k];
              var f = (target - a.l) / Math.max(b.l - a.l, 0.0001);
              hit = { x: a.x + (b.x - a.x) * f, y: a.y + (b.y - a.y) * f };
              break;
            }
          }
          out.push(hit);
        }
        return out;
      }

      // Even-EDGE respacing params for vertical sunburst stacks, captured per branch
      // (sidebar / side-logo). null → no respacing (top-header uses even-angle).
      var _re = null;
      if (sidebarLeft || sidebarRight) {
        // Sidebar radial: the arc is ROTATED 90° and wraps the LOGO (cx/cy), bulging
        // OUT into the content. CONSTANT vertical spacing (even-Y), x derived from
        // the ellipse — mirror of the side-logo top-header branch. The vertical
        // RANGE follows the logo position so points stay on-screen and the shape
        // matches the top header: a QUARTER for top/bottom, a HALF for centre.
        var xSignSb = sidebarLeft ? 1 : -1;                 // bulge toward content
        var chordX = cx;
        var cySb = cy;
        var rxSb = base;
        var logoFrac = nRect.height > 0 ? logoCy / nRect.height : 0.5;
        // Fit the arc to the space actually available on the logo's open side so
        // points never run off-screen (the bug at logo-bottom). rEll is the
        // desired radius; clamp it to the room above / below the logo.
        var rEll = base * 1.8;
        var mgn = 12;
        var spaceUp = Math.max(20, cySb - mgn);
        var spaceDown = Math.max(20, nRect.height - cySb - mgn);
        var rySb, yLo, yHi;
        if (logoFrac < 0.4) { rySb = Math.min(rEll, spaceDown); yLo = 0; yHi = rySb; }        // top → quarter, fan below
        else if (logoFrac > 0.6) { rySb = Math.min(rEll, spaceUp); yLo = -rySb; yHi = 0; }    // bottom → quarter, fan above
        else { rySb = Math.min(rEll, spaceUp, spaceDown); yLo = -rySb; yHi = rySb; }           // centre → half
        // Offset curve: y runs linearly yLo→yHi (so even-u == even vertical
        // spacing), x bulges out from the ellipse (0 at the ends).
        var sbPoint = function (u) {
          var yy = yLo + (yHi - yLo) * u;
          var fr = 1 - (yy / rySb) * (yy / rySb);
          return { x: xSignSb * rxSb * Math.sqrt(fr < 0 ? 0 : fr), y: yy };
        };
        var sbPos = [];
        if (_sunburst) {
          // Sunburst placement on a circle of radius Rsb; pills rotate along their
          // true rays via _setRot. EVEN VERTICAL spacing in every case so the
          // stacked points keep equal gaps — equal-angle compresses the vertical
          // gaps at the steep (near-vertical) end, which reads as "the last two
          // points sit closer" (user 2026-07-11). The angle step, when set, just
          // controls how WIDE the fan opens; the points stay evenly spaced within.
          var maxAngSb = 1.17;                                  // ~67°, matches the pill-tilt cap
          var Rsb = rySb / Math.sin(maxAngSb);
          var isCentreSb = !(logoFrac < 0.4 || logoFrac > 0.6);
          // Vertical HALF-extent: auto → full room; manual → derived from the step
          // (centre spans ±(n-1)·step/2, a quarter spans (n-1)·step one-sided).
          var halfSb = stepRad > 0
            ? Math.min(1.48, (isCentreSb ? (n - 1) * stepRad / 2 : (n - 1) * stepRad))
            : maxAngSb;
          var yMaxSb = Rsb * Math.sin(halfSb);
          var dirSb = logoFrac < 0.4 ? 1 : -1;                 // quarter fan direction
          // Sunburst radius follows the AVAILABLE ROOM, not the small rEll (radial
          // radius) — a tiny rEll leaves no headroom for the fan to open, so the
          // Fan-spread slider would sit maxed and do nothing (user 2026-07-11). Cap
          // it so a very tall sidebar doesn't fill top-to-bottom. The polar model
          // keeps the ring at THIS fixed radius; Fan spread only fans within it.
          // Desired radius = the merchant's "Radiale Größe" (distance to the logo),
          // so a small setting sits the points CLOSE (user 2026-07-12: 60px must read
          // as ~60px, not ~350px). The polar block only GROWS it when the pills would
          // collide; the available room (reach) is now just an upper cap so the fan
          // never overflows the sidebar. The polar model decoupled the fan from the
          // radius (fan opens angularly), so driving R off `reach` is obsolete.
          // Rmax = the ACTUAL room on the logo's open side (independent of the
          // merchant radius). At full fan the extreme point sits ~R·sin(85°) ≈ R from
          // the logo, so capping R at the room keeps every point on-screen while still
          // letting the collision floor grow R when a small radius would overlap.
          var reachSb = Math.min(360, isCentreSb ? Math.min(spaceUp, spaceDown) : (logoFrac < 0.4 ? spaceDown : spaceUp));
          _re = { R: base, Rmax: reachSb, ox: chordX, oy: cySb, xs: xSignSb, centre: isCentreSb, dir: dirSb, yMax: yMaxSb };
          for (var sa = 0; sa < n; sa++) {
            var frSb = n === 1 ? 0.5 : sa / (n - 1);
            var yySb = isCentreSb ? (-yMaxSb + 2 * yMaxSb * frSb) : (dirSb * yMaxSb * frSb);
            sbPos.push({ x: xSignSb * Math.sqrt(Math.max(0, Rsb * Rsb - yySb * yySb)), y: yySb });
          }
        } else {
          var sbMode = dist === 'auto' ? 'rows' : dist;
          if (sbMode === 'arc') {
            sbPos = evenArc(sbPoint, n, 200);                   // even along the curve
          } else {
            for (var sq = 0; sq < n; sq++) sbPos.push(sbPoint(n === 1 ? 0.5 : sq / (n - 1)));  // even vertical rows
          }
        }
        visible.forEach(function (item, i) {
          var p = sbPos[i];
          item.style.left = (chordX + p.x) + 'px';
          item.style.top = (cySb + p.y) + 'px';
          // Dropdowns open toward the content side; align the INNER edge (toward the
          // logo) to the arc and pivot the pill about that edge so it stays welded to the
          // radius as it tilts — "randbündig" (user 2026-07-12).
          var sideSb = sidebarLeft ? 'right' : 'left';
          item.setAttribute('data-radial-side', sideSb);
          item.style.transform = 'translate(' + (sidebarLeft ? '0%' : '-100%') + ', -50%)';
          if (_sunburst) item.style.setProperty('--ne-radial-origin', (sidebarLeft ? '0%' : '100%') + ' 50%');
          _setRot(item, p.x, p.y);
        });
      } else if (logoLeft || logoRight) {
        // Side logo: a vertical quarter arc with CONSTANT VERTICAL spacing
        // (even Y), x derived from the ellipse. Items run from the logo's
        // height (max x, beside the logo) curving in to directly above/below
        // the logo (x → 0). Equal vertical gaps regardless of the ellipse.
        var xSign = logoLeft ? 1 : -1;                      // open toward the content side
        // Offset curve: y runs linearly 0→±ry (even-u == even vertical spacing),
        // x keeps a horizontal floor so the lowest item never curves back UNDER
        // the logo (which sits at the viewport edge → it would be clipped):
        // 1.0 beside the logo → 0.4 at the far end (never 0).
        var slPoint = function (u) {
          var yy = ySign * ry * u;
          var fr = 1 - (yy / ry) * (yy / ry);
          var frac = 0.4 + 0.6 * Math.sqrt(fr < 0 ? 0 : fr);
          return { x: xSign * rx * frac, y: yy };
        };
        var slPos = [];
        if (_sunburst) {
          // Quarter fan on a circle with EVEN VERTICAL spacing (equal stacked gaps;
          // equal-angle bunched the far end — user 2026-07-11). Pills rotate along
          // their rays via _setRot. Auto → full room; manual → step sets the spread.
          var maxAngSl = 1.17;                               // ~67°
          var Rsl = ry / Math.sin(maxAngSl);
          var halfSl = stepRad > 0 ? Math.min(1.48, (n - 1) * stepRad) : maxAngSl;
          var yMaxSl = Rsl * Math.sin(halfSl);
          // R = merchant "Radiale Größe" (distance to the logo). Rmax = real room the
          // quarter fans into (the hero below/above the side logo), NOT ry (which scales
          // with the merchant radius and would strangle the collision floor). Polar block
          // grows R only when a small radius would overlap (user 2026-07-12).
          var reachSl = Math.min(320, (window.innerHeight || 800) * 0.42);
          _re = { R: base, Rmax: reachSl, ox: cx, oy: cy, xs: xSign, centre: false, dir: ySign, yMax: yMaxSl };
          for (var la = 0; la < n; la++) {
            var yySl = ySign * yMaxSl * (n === 1 ? 0.5 : la / (n - 1));
            slPos.push({ x: xSign * Math.sqrt(Math.max(0, Rsl * Rsl - yySl * yySl)), y: yySl });
          }
        } else {
          var slMode = dist === 'auto' ? 'rows' : dist;
          if (slMode === 'arc') {
            slPos = evenArc(slPoint, n, 200);                // even along the curve
          } else {
            for (var lq = 0; lq < n; lq++) slPos.push(slPoint(n === 1 ? 0.5 : lq / (n - 1)));  // even vertical rows
          }
        }
        visible.forEach(function (item, i) {
          var p = slPos[i];
          item.style.left = (cx + p.x) + 'px';
          item.style.top = (cy + p.y) + 'px';
          // Side logo sits at the viewport edge, so ALL dropdowns must open toward
          // the content side (logo-left → right, logo-right → left) — deriving the
          // side from xx let points near the logo go 'centre'/'left' and the menu
          // opened off-screen. Align the logo-nearest item edge to the arc and pivot the
          // pill about that edge — "randbündig" (user 2026-07-12).
          var _side = logoLeft ? 'right' : 'left';
          item.setAttribute('data-radial-side', _side);
          item.style.transform = 'translate(' + (logoLeft ? '0%' : '-100%') + ', -50%)';
          if (_sunburst) item.style.setProperty('--ne-radial-origin', (logoLeft ? '0%' : '100%') + ' 50%');
          _setRot(item, p.x, p.y);
        });
      } else {
        // Centred logo: half-ellipse running left → bottom → right. The
        // vertical-spread setting raises ry, so a taller arc lifts the lowest
        // point off the row above.
        //   arc  → even spacing ALONG the arc length (smoothest transition)
        //   rows → even spacing in X (evenly spaced columns draped on the arc)
        // Uncap the tilt here so the straight-down middle pill reaches a full 90°.
        _noTiltCap = _sunburst;
        var startA = Math.PI, sweepA = -Math.PI;            // left → bottom → right
        var cArcPoint = function (u) {
          var aa = startA + sweepA * u;
          return { x: Math.cos(aa) * rx, y: ySign * Math.sin(aa) * ry };
        };
        var cPos = [];
        if (_sunburst) {
          // Hand the placement to the POLAR block below (down-axis): a symmetric fan
          // BELOW the centred logo on a fixed-radius circle, with the same collision
          // floor + equal-angle spacing as the side layouts — so the top-centred header
          // no longer overlaps (user 2026-07-12, Bild 10). Room cap from the viewport
          // width (the fan spreads sideways). cPos below is only a throwaway initial.
          var reachC = Math.min(340, (window.innerWidth || 1200) * 0.42);
          _re = { R: base, Rmax: reachC, ox: cx, oy: cy, centre: true, axis: 'down', ySign: ySign };
          // Even-ANGLE fan (clean sunburst): cArcPoint's angle is linear in u, so
          // sampling at even u gives EQUAL angular steps — a regular sun-ray spread
          // below the logo (user 2026-07-11). Overrides arc/rows spacing.
          if (stepRad > 0) {
            // Manual spacing symmetric about the straight-DOWN (bottom) ray.
            for (var ca = 0; ca < n; ca++) {
              var bC = Math.max(-1.48, Math.min(1.48, (ca - (n - 1) / 2) * stepRad));
              cPos.push({ x: Math.sin(bC) * rx, y: ySign * Math.cos(bC) * ry });
            }
          } else {
            for (var ca2 = 0; ca2 < n; ca2++) cPos.push(cArcPoint(n === 1 ? 0.5 : ca2 / (n - 1)));
          }
        } else {
          var cMode = dist === 'auto' ? 'arc' : dist;
          if (cMode === 'rows') {
            for (var cq = 0; cq < n; cq++) {
              var xt = n === 1 ? 0 : (-rx + 2 * rx * (cq / (n - 1)));   // even X, left → right
              var rr = 1 - (xt / rx) * (xt / rx);
              cPos.push({ x: xt, y: ySign * ry * Math.sqrt(rr < 0 ? 0 : rr) });
            }
          } else {
            cPos = evenArc(cArcPoint, n, 240);                          // even along the curve
          }
        }
        visible.forEach(function (item, i) {
          var pt = cPos[i];
          item.style.left = (cx + pt.x) + 'px';
          item.style.top = (cy + pt.y) + 'px';
          // Align the edge NEAREST the logo to the arc (not the centre): items
          // left of the logo → right edge on the arc, right → left edge, the
          // top-centre item stays centred. data-radial-side drives the dropdown
          // alignment + the underline sweep direction (left items right-align).
          var _side = pt.x < -18 ? 'left' : (pt.x > 18 ? 'right' : 'center');
          item.setAttribute('data-radial-side', _side);
          // Top-centred sunburst: pills LEFT of the middle align their RIGHT edge to the
          // arc (rechtsbündig), pills RIGHT align their LEFT edge (linksbündig), so every
          // inner edge converges on the circle; the straight-down MIDDLE pill (vertical at
          // 90°) centre-anchors so it sits symmetric on its point (user 2026-07-12). The
          // rotation pivots about that same edge so it stays welded to the radius.
          item.style.transform = 'translate(' + (_side === 'left' ? '-100%' : (_side === 'right' ? '0%' : '-50%')) + ', -50%)';
          if (_sunburst) item.style.setProperty('--ne-radial-origin', (_side === 'left' ? '100%' : (_side === 'right' ? '0%' : '50%')) + ' 50%');
          _setRot(item, pt.x, pt.y);
        });
      }
      // POLAR sunburst placement (vertical stacks: sidebar + side-logo). Points sit
      // on a circle of radius Rfix around the logo; each pill is re-aimed ALONG its
      // ray by _setRot. Distribution = EVEN EDGE-to-edge VERTICAL gaps — that is what
      // "evenly spaced" reads as (user 2026-07-12): equal ANGLE looks even upright but
      // the sin() compresses the vertical gaps toward the ends (first gap big, last
      // small on a quarter), which the merchant sees as uneven. So we space the pills
      // by equal vertical EDGE gaps, then map each y back onto the circle (x = √(R²−y²))
      // so the distance to the logo stays = R.
      //   • Radius: the ring sits at the merchant "Radiale Größe"; it only GROWS when
      //     the collision stack is taller than the circle can hold, capped by the room.
      //   • Fan spread (stepRad) widens the gaps toward filling the room.
      //   • Whole-fan ROTATION adds rotRad to every ray AFTER the even-Y layout, so it
      //     spins the ring. NO angular clamp — a hard rotation slides points off-screen
      //     rather than piling them at a limit (user 2026-07-12, Bild 13).
      // offset* read once (no reflow); three passes so the per-pill tilt (which sets
      // the rotated height) settles.
      if (_sunburst && _re && n > 1) {
        var MIN_GAP = 8;                                        // min vertical edge gap
        var _links = visible.map(function (item) { return item.querySelector('.ne-header__nav-link') || item; });
        var _dims = _links.map(function (l) { return { w: l.offsetWidth, h: l.offsetHeight }; });
        var maxAng = 1.40;                                      // ~80° end-tilt cap (matches _setRot)
        var SPAN = 1.50;                                        // ~86° — furthest a point may sit
        var Rmax = _re.Rmax || 1e9;                             // room cap — fan never overflows
        var Rfix = Math.min(_re.R, Rmax);                       // seed (settled in the pass loop)
        // In the Sunburst the merchant "Radiale Größe" acts as a SCALING FACTOR on the
        // natural radius (user 2026-07-12: chose factor over raw px — a raw px was
        // swallowed by the collision floor). 120 (default) = 1.0×; 60 → 0.5×, 260 → ~2.2×.
        var _rFactor = (_re.R || 120) / 120;
        var frac = Math.min(1, stepRad / (45 * Math.PI / 180));
        var _phis = visible.map(function () { return 0; });     // ray TILT per point (settles pass→pass)
        // Two fan axes: 'side' fans around the horizontal (sidebar / side-logo — angle
        // measured from horizontal, x = xs·cos, y = sin); 'down' fans around straight-down
        // (centred top-header — angle measured from the down ray, x = sin, y = ySign·cos).
        var _down = _re.axis === 'down';
        var placeAng = function (item, ang, idx) {
          var xx, yy;
          if (_down) { xx = Rfix * Math.sin(ang); yy = _re.ySign * Rfix * Math.cos(ang); }
          else { xx = _re.xs * Rfix * Math.cos(ang); yy = Rfix * Math.sin(ang); }
          // Store the pill's actual TILT (ray angle from horizontal, folded into the
          // readable half) so the collision extent knows how far it exceeds the tilt cap —
          // works for either axis since it's read straight off the geometry.
          var raw = Math.atan2(yy, xx);
          if (raw > Math.PI / 2) raw -= Math.PI; else if (raw < -Math.PI / 2) raw += Math.PI;
          _phis[idx] = raw;
          item.style.left = (_re.ox + xx) + 'px';
          item.style.top = (_re.oy + yy) + 'px';
          _setRot(item, xx, yy);
          // Down-axis (centred top-header): pick the edge to weld to the arc from the
          // pill's ACTUAL lean, not a static left/right position — a pill leaning right
          // (positive tilt, incl. the straight-down middle) sits on its LEFT edge, leaning
          // left → RIGHT edge, dead level → centre. Because it reads the final tilt here,
          // it updates as the fan is ROTATED, so the middle never hangs upside-down and
          // aligns with its neighbours on that side (user 2026-07-12).
          if (_down) {
            var _rr = parseFloat(item.style.getPropertyValue('--ne-radial-rot')) || 0;
            // Edge-anchor the pill ON THE LINK (--ne-radial-shift) and keep the ITEM
            // centred on its point, so the dropdown drops straight DOWN centred on the
            // point instead of being dragged sideways/up over the fanned points by an
            // item anchor transform (user 2026-07-12, D). Lean right (positive tilt,
            // incl. the straight-down middle) → LEFT edge on the arc; lean left → RIGHT;
            // dead level → centre. Reads the FINAL tilt so it updates under rotation.
            item.style.transform = 'translate(-50%, -50%)';
            item.style.setProperty('--ne-radial-shift', _rr > 0.03 ? '50%' : (_rr < -0.03 ? '-50%' : '0%'));
            item.style.setProperty('--ne-radial-origin', (_rr > 0.03 ? '0%' : (_rr < -0.03 ? '100%' : '50%')) + ' 50%');
            item.setAttribute('data-radial-side', 'center');   // dropdown: centred + straight down
          }
        };
        for (var _pass = 0; _pass < 3; _pass++) {
          // EQUAL-ANGLE spacing (the sun-ray look the merchant approved 2026-07-12):
          // every ray sits at the same angular step around the logo. The collision
          // floor uses the TANGENTIAL (cross-ray) extent — because each pill rotates to
          // line up with its ray, only its THICKNESS (line-height) collides with its
          // neighbour, so long labels still pack CLOSE and the merchant radius is
          // honoured (it only grows if the fan can't fit the ±SPAN window).
          var exts = _dims.map(function (d, i) {
            var dth = Math.max(0, Math.abs(_phis[i]) - maxAng);
            return Math.abs(d.w * Math.sin(dth)) + Math.abs(d.h * Math.cos(dth));
          });
          var clr = MIN_GAP;
          for (var ci = 1; ci < n; ci++) clr = Math.max(clr, exts[ci - 1] / 2 + exts[ci] / 2 + MIN_GAP);
          var cap = _re.centre ? (2 * SPAN) : SPAN;
          // Radius = SCALING FACTOR on the natural radius, clamped between the collision
          // floor (tightest that fits the fan in ±cap without overlap) and the room (never
          // overflows). So "Radiale Größe" scales the fan distance; the collision floor
          // still guarantees no overlap at the small end (user 2026-07-12).
          var Rcoll = (n - 1) * clr / cap;                       // collision floor
          var Rauto = Math.min(Rmax, Rcoll * 1.5);               // neutral (1.0×) radius
          Rfix = Math.max(Rcoll, Math.min(Rmax, Rauto * _rFactor));
          var reqSpan = (n - 1) * clr / Rfix;
          // Fan spread opens the span from the collision floor toward the full window.
          var useSpan = reqSpan + (cap - reqSpan) * frac;
          var step = useSpan / (n - 1);
          // Place at equal angular steps, then spin the whole fan by rotRad. NO clamp —
          // a hard rotation slides points off-screen instead of piling at a limit.
          for (var pi = 0; pi < n; pi++) {
            var phi = (_re.centre ? (-useSpan / 2 + pi * step) : (_re.dir * pi * step)) + rotRad;
            placeAng(visible[pi], phi, pi);
          }
        }
      }
      // Per-point dropdown OPENING direction + anchor (user 2026-07-12, full spec).
      // The panel's NEAR edge sits at the point and it opens AWAY from the logo so it
      // never covers the logo/other points and never runs off-screen. Split by layout:
      //   • Sidebar (vertical spine): point ABOVE the arc centre (cy) → open UP (panel
      //     bottom edge at the point); at/below → open DOWN (top edge). Panel sits BESIDE
      //     on the content side. Covers logo-oben (all down), logo-unten (all up),
      //     logo-mittig (split at the middle point).
      //   • Side-logo top header (logo left/right): ALL open DOWN, top edge at the point,
      //     beside on the content side (like sidebar logo-oben).
      //   • Centred top header: point RIGHT of the logo → open RIGHT, LEFT → open LEFT
      //     (top edge at the point, beside); a dead-centre point opens DOWN centred.
      // data-radial-side is (re)stamped for the centred fan-out so each dropdown insets
      // to its own side; data-radial-vflip is kept in sync for the underline / trace.
      var _sideBar = sidebarLeft || sidebarRight;
      var _sideLogo = !_sideBar && (logoLeft || logoRight);
      // Classify the sidebar logo position GLOBALLY from where the point cluster sits
      // relative to the arc origin (the fan wraps the logo, so a per-point `y<=cy` test
      // wrongly flips the topmost point — it sits at ≈cy). cluster BELOW the logo (bias
      // > 0) = logo oben → ALL down; cluster ABOVE = logo unten → ALL up; straddling =
      // logo mittig → split at the middle point (user 2026-07-12).
      var _sbBias = 0, _sbThr = 0;
      if (_sideBar) {
        var _ys = visible.map(function (it) { return parseFloat(it.style.top) || 0; });
        var _minY = Math.min.apply(null, _ys), _maxY = Math.max.apply(null, _ys);
        _sbBias = (_minY + _maxY) / 2 - cy;
        _sbThr = Math.max(12, (_maxY - _minY) * 0.12);
      }
      visible.forEach(function (item) {
        var _y = parseFloat(item.style.top) || 0;
        var _x = parseFloat(item.style.left) || 0;
        var _open;
        if (_sideBar) {
          if (_sbBias > _sbThr) _open = 'down';          // logo oben → all down
          else if (_sbBias < -_sbThr) _open = 'up';      // logo unten → all up
          else _open = _y < cy ? 'up' : 'down';          // mittig → split (middle opens down)
        } else if (_sideLogo) {
          _open = 'down';
        } else {
          var _dx = _x - cx;
          if (_dx > 18) { _open = 'right'; item.setAttribute('data-radial-side', 'right'); }
          else if (_dx < -18) { _open = 'left'; item.setAttribute('data-radial-side', 'left'); }
          else { _open = 'down'; item.setAttribute('data-radial-side', 'center'); }
        }
        item.setAttribute('data-radial-open', _open);
        item.setAttribute('data-radial-vflip', _open === 'up' ? 'up' : 'down');
        // Horizontal alignment of the up/down panels: edge-align to the tip — left
        // sidebar / side-logo-left → LEFT edge on the tip, right → RIGHT edge; the centred
        // top-header's straight-down middle stays CENTRED (user 2026-07-12: "linksbündig
        // bei linker Sidebar, rechtsbündig bei rechter"). Left/right OPENS ignore it.
        var _halign;
        if (_sideBar) _halign = sidebarLeft ? 'left' : 'right';
        else if (_sideLogo) _halign = logoLeft ? 'left' : 'right';
        else _halign = 'center';
        item.setAttribute('data-radial-halign', _halign);
        // Anchor the dropdown on the pill's OUTER TIP — the end of the ray AWAY from the
        // logo — centred on it (user 2026-07-12: "immer mittig am Außenpunkt des Nav-
        // Punktes"). The pill rotates about its inner edge, so we reconstruct the two ray
        // ends from the bbox centre ± half the (unrotated) length along the ray, then take
        // the end farther from the arc origin. Exposed as px offsets from the item box so
        // the panel emanates from the visible tip regardless of tilt.
        var _lnk = item.querySelector('.ne-header__nav-link') || item;
        var _ir = item.getBoundingClientRect();
        var _lr = _lnk.getBoundingClientRect();
        var _pcx = _lr.left + _lr.width / 2, _pcy = _lr.top + _lr.height / 2;
        // --ne-radial-rot is set on the ITEM (inherited by the link's transform), so read
        // it there — reading the link's own inline style returns '' and collapses the tip.
        var _rot = parseFloat(item.style.getPropertyValue('--ne-radial-rot')) || 0;
        var _ux = Math.cos(_rot), _uy = Math.sin(_rot);
        var _half = (_lnk.offsetWidth || _lr.width) / 2;
        var _Lx = nRect.left + cx, _Ly = nRect.top + cy;   // arc origin (viewport)
        var _e1x = _pcx + _half * _ux, _e1y = _pcy + _half * _uy;
        var _e2x = _pcx - _half * _ux, _e2y = _pcy - _half * _uy;
        var _d1 = (_e1x - _Lx) * (_e1x - _Lx) + (_e1y - _Ly) * (_e1y - _Ly);
        var _d2 = (_e2x - _Lx) * (_e2x - _Lx) + (_e2y - _Ly) * (_e2y - _Ly);
        var _oex = _d1 >= _d2 ? _e1x : _e2x, _oey = _d1 >= _d2 ? _e1y : _e2y;
        item.style.setProperty('--ne-rr-oy',    (_oey - _ir.top).toFixed(1) + 'px');
        item.style.setProperty('--ne-rr-obot',  (_ir.bottom - _oey).toFixed(1) + 'px');
        item.style.setProperty('--ne-rr-ox',    (_oex - _ir.left).toFixed(1) + 'px');
        item.style.setProperty('--ne-rr-oright', (_ir.right - _oex).toFixed(1) + 'px');
      });
      // Scroll-hide transform origins (user 2026-07-11), in nav-local px, recomputed
      // each run so they track resize/scroll: SCALE shrinks toward the items'
      // CENTROID (no drift wherever the logo sits) — the earlier default `center`
      // used the full-height nav box and dragged the points; COLLAPSE shrinks toward
      // the real LOGO centre (logoCx/logoCy, pre-offset).
      var _oX = 0, _oY = 0, _oN = 0;
      visible.forEach(function (item) {
        _oX += parseFloat(item.style.left) || 0;
        _oY += parseFloat(item.style.top) || 0;
        _oN++;
      });
      if (_oN) nav.style.setProperty('--ne-nav-scale-origin', (_oX / _oN) + 'px ' + (_oY / _oN) + 'px');
      nav.style.setProperty('--ne-nav-collapse-origin', logoCx + 'px ' + logoCy + 'px');
    }

    // Equal-width nav buttons: give every nav link the width of the widest one
    // (opt-in). Measure natural widths after a reset, then publish the max as a
    // CSS var the links read for equal sizing. In normal nav this equalises
    // WIDTH (--ne-nav-btn-width). In spine mode the links are rotated, so
    // "equal" means equal LENGTH (vertical extent): measure the tallest pill
    // and publish --ne-nav-btn-length (a min-height the spine CSS reads).
    function applyEqualNavWidth(nav) {
      var header = nav.closest('.ne-header');
      if (!header) return;
      var links = Array.prototype.slice.call(nav.querySelectorAll('.ne-header__nav-link'));
      links.forEach(function (l) { l.style.removeProperty('width'); });
      if (!header.classList.contains('ne-header--nav-equal-width')) {
        header.style.removeProperty('--ne-nav-btn-width');
        header.style.removeProperty('--ne-nav-btn-length');
        return;
      }
      // Real (non-More) links, with their items SHOWN so the measured max is a
      // stable constant even if the overflow pass collapsed some into "More".
      // equal-width runs BEFORE overflow in the call order; overflow then
      // re-hides as needed. (Un-hiding here is undone by the overflow pass.)
      var measured = links.filter(function (l) {
        var it = l.closest('.ne-header__nav-item');
        return it && !it.classList.contains('ne-header__nav-item--more') &&
          !it.classList.contains('ne-header__nav-item--more-child');
      });
      measured.forEach(function (l) { var it = l.closest('.ne-header__nav-item'); if (it) it.style.display = ''; });
      if (header.classList.contains('ne-header--sb-spine')) {
        // Reset the floor first so links report their natural length, then
        // floor everyone to the tallest.
        header.style.removeProperty('--ne-nav-btn-width');
        header.style.removeProperty('--ne-nav-btn-length');
        var maxH = 0;
        measured.forEach(function (l) {
          var h = l.getBoundingClientRect().height;
          if (h > maxH) maxH = h;
        });
        if (maxH > 0) header.style.setProperty('--ne-nav-btn-length', Math.ceil(maxH) + 'px');
        return;
      }
      header.style.removeProperty('--ne-nav-btn-length');
      var maxW = 0;
      measured.forEach(function (l) {
        var w = l.getBoundingClientRect().width;
        if (w > maxW) maxW = w;
      });
      if (maxW > 0) header.style.setProperty('--ne-nav-btn-width', Math.ceil(maxW) + 'px');
      else header.style.removeProperty('--ne-nav-btn-width');
    }

    function initOverflowObserver(globalMegaMode, moreMegaTemplate) {
      var nav = document.querySelector('[data-ne-nav-root="text"]');
      if (!nav) return;
      var header = nav.closest('.ne-header');
      if (!header) return;
      // equal-width BEFORE overflow: it stabilises the link sizes (and un-hides
      // items to measure a constant max) so the overflow pass measures the final
      // sizes and collapses the right items into "More".
      // ⚠️ Die beiden MESSENDEN Durchgaenge laufen nur, wenn sich etwas geaendert hat,
      // das ihr Ergebnis beeinflussen kann. runPasses wird sonst mindestens viermal
      // sicher gefahren (sofort, doppeltes rAF, 250-ms-Timeout, fonts.ready) plus bei
      // jedem ResizeObserver — und rechnet dabei meist dasselbe Ergebnis neu. Im
      // Trace vom 2026-07-30 (21rebel mobil) standen applyOverflowNav und sizeOf mit
      // je 10 erzwungenen Stilneuberechnungen an der Spitze der Ausloeserliste;
      // erzwungene Neuberechnung kostete dort 825 ms von 1.797 ms gesamt.
      //
      // In die Signatur gehoert alles, was die Rechnung kippen kann: die Groesse des
      // Containers, der Ladezustand der Schriften (eine spaet geladene Schrift misst
      // andere Pillenlaengen — genau der Grund fuer die Nachlaeufe oben), die
      // Header-Klassen (Variante, Anordnung, Ausrichtung) und die Zahl der Eintraege.
      // querySelectorAll zaehlt auch die ausgeblendeten mit, die Zahl schwankt durch
      // den Ausblend-Durchgang also NICHT.
      // Klassen, die der Header beim SCROLLEN umschaltet. Sie aendern am Ueberlauf
      // nichts (dieselbe Unterscheidung trifft der Klassen-Beobachter weiter unten,
      // aus demselben Grund). Blieben sie in der Signatur, wuerde jeder Scrollwechsel
      // sie kippen und den teuren Durchgang beim naechsten ResizeObserver ausloesen —
      // die Pruefung liefe genau dann ins Leere, wo sie am meisten spart.
      var SCROLL_CLASSES = { 'ne-header--scrolled': 1, 'ne-header--open-up': 1 };
      var TRANSFORM_ONLY = { 'ne-header--nav-scrolling': 1, 'ne-header--nav-revealed': 1 };
      var letzteSignatur = null;
      var signatur = function () {
        var kl = Array.prototype.filter.call(header.classList, function (c) {
          return !SCROLL_CLASSES[c] && !TRANSFORM_ONLY[c];
        }).sort().join(' ');
        return header.clientWidth + 'x' + header.clientHeight +
          '|' + ((document.fonts && document.fonts.status) || '') +
          '|' + kl +
          '|' + nav.querySelectorAll(':scope > .ne-header__nav-item').length;
      };
      var runPasses = function () {
        if (signatur() !== letzteSignatur) {
          applyEqualNavWidth(nav);
          applyOverflowNav(nav, globalMegaMode, moreMegaTemplate);
          // NACH den Durchgaengen merken, nicht davor: in der Seitenleiste kann der
          // Ausblend-Durchgang die Containerhoehe minimal verschieben. Gegen den
          // Vorher-Stand verglichen wuerde der naechste Aufruf dann erneut rechnen,
          // obwohl sich nichts Relevantes geaendert hat.
          letzteSignatur = signatur();
        }
        applyRadialNav(nav);
        initMoreFlyoutFlip(nav);
        initSubmenuFlip(nav);
        initTopMergeBrackets(nav);
        initBtnMenuFlip(nav);
      };
      runPasses();
      // Re-run after layout + webfonts settle. The first pass can run before the
      // webfont loads (rotated spine pills then measure short) or before the logo
      // image decodes, so the initial overflow calc can miss. A static sidebar
      // never fires the ResizeObserver again, so without these deferred re-runs
      // the vertical collapse would never correct itself.
      requestAnimationFrame(function () { requestAnimationFrame(runPasses); });
      setTimeout(runPasses, 250);
      if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
        document.fonts.ready.then(runPasses).catch(function () {});
      }
      if (state.navResizeObs) { state.navResizeObs.disconnect(); state.navResizeObs = null; }
      if (typeof ResizeObserver === 'function') {
        var schedule = null;
        // Observe the HEADER, not the nav. applyOverflowNav() toggles
        // nav display:none mid-measurement — observing the nav would feed
        // that mutation back into the observer and cause an infinite loop.
        state.navResizeObs = new ResizeObserver(function () {
          if (schedule) return;
          schedule = requestAnimationFrame(function () {
            schedule = null;
            runPasses();
          });
        });
        state.navResizeObs.observe(header);
      }
      // Recompute the radial arc when the header's classes change — e.g. the
      // open-up flip toggling on scroll (header low ↔ pinned top), or the
      // arrangement switched in the editor. applyRadialNav only sets inline
      // styles, never the header class, so there is no feedback loop.
      if (state.radialClassObs) { state.radialClassObs.disconnect(); state.radialClassObs = null; }
      if (typeof MutationObserver === 'function') {
        var rSchedule = null;
        // Classes that toggle on scroll (header low ↔ pinned top) and do NOT
        // affect the overflow collapse. Re-running runPasses for these re-clones
        // the "More" panel on every scroll tick, which replayed the open
        // animation and reset any open flyout (user 2026-06-23). --open-up only
        // matters in radial mode (it flips the arc), so it's overflow-irrelevant
        // for inline/spine and handled below.
        // SCROLL_CLASSES und TRANSFORM_ONLY sind weiter oben deklariert — die
        // Signaturpruefung von runPasses blendet dieselben Klassen aus.
        // Transform/visibility-only classes: they fade or scale the nav but NEVER
        // move a point, so a re-run is both pointless AND harmful — it would
        // measure the transformed nav (the scroll-reveal scale/collapse) and
        // freeze the arc at a corrupt spot (user 2026-07-11). Skip them even in
        // radial mode.

        state.radialClassObs = new MutationObserver(function (records) {
          var isRadial = header.classList.contains('ne-header--nav-arrange-radial');
          var relevant = false;
          for (var i = 0; i < records.length; i++) {
            var oldC = (records[i].oldValue || '').split(/\s+/);
            var newC = Array.prototype.slice.call(header.classList);
            var diff = oldC.filter(function (c) { return c && newC.indexOf(c) < 0; })
                          .concat(newC.filter(function (c) { return oldC.indexOf(c) < 0; }));
            for (var j = 0; j < diff.length; j++) {
              var cc = diff[j];
              if (TRANSFORM_ONLY[cc]) continue;                 // never reposition for these
              if (!isRadial && SCROLL_CLASSES[cc]) continue;    // scroll-only: skip in non-radial
              relevant = true; break;
            }
            if (relevant) break;
          }
          if (!relevant) return;
          if (rSchedule) return;
          rSchedule = requestAnimationFrame(function () {
            rSchedule = null;
            // Full pass (not just equal-width + radial): a header-class change
            // must also re-run the overflow collapse, else the sidebar's
            // vertical "More" gets un-hidden by equal-width and never re-folds.
            // applyOverflowNav only toggles item display (no header class), so
            // there's still no feedback loop on this class observer.
            runPasses();
          });
        });
        state.radialClassObs.observe(header, { attributes: true, attributeFilter: ['class'], attributeOldValue: true });
      }
    }

    // --- Run --------------------------------------------------------------
    function run() {
      var marker = document.querySelector('[data-ne-header-sync]');
      if (marker) syncHeaderClasses(marker);
      publishHeaderBottom();
      publishSidebarWidth();
      wireLogoLoadMetrics();

      var islands = document.querySelector('[data-ne-block-islands]');
      if (!islands) return;
      var tpls = collectTemplates(islands);

      var navRoot = document.querySelector('[data-ne-nav-root]');
      var slots = navRoot ? Array.prototype.slice.call(navRoot.querySelectorAll('[data-ne-nav-slot]')) : [];

      var iconResult = { decisions: [], usedIdx: new Set() };
      if (navRoot && navRoot.getAttribute('data-ne-nav-root') === 'icon') {
        iconResult = pairIcons(slots, tpls.icons);
        iconResult.decisions.forEach(applyIconDecision);
      }

      // Megamenus are full-width panels anchored under their trigger. In RADIAL
      // mode the triggers are absolutely-positioned points scattered around the
      // logo, so a mega has nothing sensible to align to (user 2026-07-12) → skip
      // promotion entirely and let those links fall back to plain dropdowns.
      var _navHeader = navRoot ? navRoot.closest('.ne-header') : document.querySelector('.ne-header');
      var _radialNav = !!(_navHeader && _navHeader.classList.contains('ne-header--nav-arrange-radial'));
      if (!_radialNav) {
        var megaResult = pairMegamenus(slots, tpls.megas);
        megaResult.decisions.forEach(promoteToMegamenu);
      }

      // Global megamenu mode: if any megamenu_link block exists, every
      // remaining plain dropdown is upgraded to a megamenu panel so the
      // menu system reads uniformly (Horizon parity). Also tags the header
      // with a modifier class so CSS can adjust where needed. Never in radial.
      var globalMegaMode = tpls.megas.length > 0 && !_radialNav;
      var headerEl = document.querySelector('.ne-header');
      if (headerEl) headerEl.classList.toggle('ne-header--global-mega', globalMegaMode);
      if (globalMegaMode && navRoot) {
        var remainingHosts = Array.prototype.slice.call(
          navRoot.querySelectorAll('.ne-header__nav-item--has-dropdown:not(.ne-header__nav-item--has-megamenu)')
        );
        var _asideTpl = tpls.megas[0] || null;
        remainingHosts.forEach(function (host) { synthesizeMegamenu(host, _asideTpl); });
      }

      initBtnMenuFlip(navRoot);

      var drawerRoot = document.querySelector('[data-ne-drawer-nav-root]');
      if (drawerRoot) {
        var drawerResult = pairDrawerIcons(drawerRoot, tpls.icons);
        drawerResult.decisions.forEach(applyDrawerIconDecision);
        // Clear + re-inject each run(); injectDrawerCarousels handles the
        // single bottom slot itself (Horizon-style, not per-accordion).
        injectDrawerCarousels(drawerRoot, tpls.carousels);
      }

      renderPairingPreview({
        slots: slots,
        iconTemplates: tpls.icons,
        iconDecisions: iconResult.decisions,
        usedIconIdx: iconResult.usedIdx
      });

      // First megamenu template (if any) — used as the More-panel shell so
      // the overflow dropdown inherits heading + aside + columns config 1:1.
      // Flag a rebuild so ensureMoreItem picks up the freshly-rendered template
      // on this run (Customizer edits to the megamenu block reach us here via
      // the block-islands MutationObserver).
      state.moreNeedsRebuild = true;
      initOverflowObserver(globalMegaMode, tpls.megas[0] || null);
    }

    // Stash observers on window so repeated init() calls (from multiple
    // block re-renders) disconnect stale ones instead of leaking them.
    var state = (window.__NEMenu = window.__NEMenu || { markerObs: null, islandsObs: null, bodyObs: null });

    // A click inside a panel (accordion summary, link) moves focus there, and the
    // CSS keeps the panel open via :focus-within — so it lingered after the mouse
    // left (user 2026-07-02). When the pointer leaves the nav (megamenus are DOM
    // descendants, so this only fires once truly outside), drop focus to release
    // :focus-within and collapse any open accordion. Keyboard users navigate with
    // Tab (no mouseleave), so their focus-open path is untouched.
    function bindNavClose() {
      Array.prototype.forEach.call(document.querySelectorAll('.ne-header__nav'), function (nav) {
        if (nav.__neNavCloseBound) return;
        nav.__neNavCloseBound = true;
        nav.addEventListener('mouseleave', function () {
          var af = document.activeElement;
          if (af && af !== document.body && nav.contains(af)) { try { af.blur(); } catch (e) {} }
          Array.prototype.forEach.call(nav.querySelectorAll('details[open]'), function (d) { d.open = false; });
        });
      });
    }

    // Merge menu — sequence direct nav→nav switches WITHOUT lagging a fresh hover.
    // Pure CSS can't tell a switch from a first open (a closing panel has no :hover to
    // match), so we drive it from mouseenter/leave: on a SWITCH set --ne-mm-open-delay
    // (the incoming panel waits CLOSE ms until the outgoing one is gone) + force the outgoing
    // to START closing at THIS mouseenter (.ne-mm-closing → pointer-events:none drops its :hover)
    // so close and open-delay share t=0 → overlap-free regardless of enter/leave order. On a
    // FRESH hover the delay stays 0 (no lag) and a single leave keeps the normal wipe-back. Runs
    // for TOP + sidebar merge; the per-item VERTICAL positioning below is sidebar-only (top panel
    // is full-width centred) → gated by isSidebar.
    function initMergeStagger() {
      var header = document.querySelector('.ne-header');
      if (!header) return;
      if (!header.classList.contains('ne-header--menu-merge')) return;
      var isSidebar = header.classList.contains('ne-header--left') || header.classList.contains('ne-header--right');
      var nav = header.querySelector('.ne-header__nav');
      if (!nav || nav.__neMmStagger) return;
      nav.__neMmStagger = true;
      var CLOSE = 250;
      // Hover-INTENT: a panel must be dwelt on ≥INTENT ms before it counts as "opened". Moving the
      // cursor to a sidebar nav point GRAZES the adjacent items' (vertically stacked) hover-pads for
      // a few ms — without intent that graze registered as an open panel, so the REAL target was
      // then treated as a mid-switch and held back CLOSE ms (the "delay on a fresh hover" + the
      // "first hover→hover overlap"). A graze (< INTENT) never opens, so it can't do that. (user 2026-07-07)
      var INTENT = 45;
      var openItem = null, openSince = 0, openDelay = 0, closingItem = null, closingSince = 0;
      // Vertically align a sidebar merge panel to ITS nav item instead of the
      // static frame-top anchor: centre the panel on the item, then clamp into
      // the frame band with a 2× corner-radius margin top AND bottom (so a low
      // item like "Alle Kollektionen" opens next to itself, bottom-flush, not
      // detached at the top). Inline !important beats the CSS `top:52 !important`.
      function px(name, fb) { var v = parseFloat(getComputedStyle(header).getPropertyValue(name)); return isNaN(v) ? fb : v; }
      function positionMergePanel(item) {
        var panel = item.querySelector(':scope > .ne-header__megamenu');
        if (!panel) {
          // Dropdown is UNIFIED with the megamenu: position:fixed, JS-anchored via --ne-dd-top
          // (item-centred, NO band-clamp) + --ne-dd-height. Panel AND its weld bracket are then both
          // position:fixed off the SAME base → visible, glued, zoom-proof, and the switch sequences
          // exactly like the megamenu (no absolute-vs-fixed divergence). (user 2026-07-07)
          var dd = item.querySelector(':scope > .ne-header__dropdown');
          if (dd) {
            // Match the ACCEPTED megamenu bracket method: integer offsetHeight + an INTEGER-SNAPPED
            // top. A fractional --ne-dd-top let the browser pixel-snap the panel to a row whose
            // painted height differed from the measured float by ~1px → the bracket's bottom fillet
            // landed BELOW the panel edge = the visible gap (worse/inconsistent per panel because the
            // fractional part varied). Integer top + integer height ⇒ the panel occupies exactly the
            // rows the bracket spans, so the fillet stays flush. The dropdown ::after bg is inset:0
            // (= the box), so the measured box IS the visible panel — no structural offset. (user 2026-07-08)
            var dh = dd.offsetHeight;
            var dir = item.getBoundingClientRect();
            item.style.setProperty('--ne-dd-top', Math.round((dir.top + dir.height / 2) - dh / 2) + 'px');
            item.style.setProperty('--ne-dd-height', dh + 'px');
          }
          return;
        }
        var mergeR = px('--ne-merge-r', 0);
        var topLimit = px('--ne-frame-offset', 8) + px('--ne-frame-padding-top', 0) + mergeR * 2;
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var botLimit = vh - (px('--ne-frame-offset', 8) + px('--ne-frame-padding-bottom', 0) + mergeR * 2);
        var ph = panel.offsetHeight;
        var ir = item.getBoundingClientRect();
        var top = (ir.top + ir.height / 2) - ph / 2;   // centre on the item
        if (top + ph > botLimit) top = botLimit - ph;  // clamp bottom first
        if (top < topLimit) top = topLimit;            // then top wins if it can't fit
        // Set on the ITEM (not the panel) so the panel-rebuild-on-open can't drop it.
        item.style.setProperty('--ne-mm-top', Math.round(top) + 'px');
        // Publish the panel height too so the DECOUPLED sidebar weld bracket (a nav-item ::before
        // pinned at the seam, not riding the panel) can span the panel's top→bottom corners.
        item.style.setProperty('--ne-mm-height', Math.round(ph) + 'px');
      }
      function positionSoon(item) {
        positionMergePanel(item);
        requestAnimationFrame(function () { positionMergePanel(item); }); // re-measure after open-rebuild
      }
      function onEnter(item) {
        // A SWITCH = another panel is still on screen when THIS item is entered: either still
        // OPEN (its mouseleave hasn't fired yet — overlapping hover-pads can fire enter BEFORE
        // leave) OR closing within the last CLOSE ms. Tracking OPEN state (not just the last
        // leave) makes the FIRST hover→hover behave like every later one regardless of the
        // enter/leave event order — fixes the first switch overlapping because lastLeave/lastLeft
        // weren't set yet. On a switch the incoming open is held --ne-mm-open-delay=CLOSE until
        // the outgoing clean close finishes (zero overlap); a fresh open has no delay. (user 2026-07-07)
        var now = Date.now();
        // This item is being (re)opened — lift any persistent force-close from a previous switch.
        item.classList.remove('ne-mm-closing');
        var prev = openItem;
        // A real SWITCH = a panel that was ACTUALLY ON SCREEN when this item is entered — either the
        // previous item was dwelt on past its own open-delay (its panel is visible) OR one is still
        // closing within the last CLOSE ms. A mere GRAZE of an adjacent item (dwelt < its open-delay,
        // so its panel never showed) is NOT a switch → the real target opens on INTENT, not held CLOSE.
        var prevVisible = prev && prev !== item && (now - openSince) >= openDelay;
        var closingVisible = closingItem && closingItem !== item && (now - closingSince) < CLOSE;
        var delay = (prevVisible || closingVisible) ? CLOSE : INTENT;
        header.style.setProperty('--ne-mm-open-delay', delay + 'ms');
        // Force the OUTGOING panel to START closing NOW (at THIS mouseenter), instead of waiting
        // for its own mouseleave — which, when the hover-pads overlap, can fire a few ms LATER and
        // leave the outgoing on screen past the incoming's open-delay (the residual overlap). With
        // the close and the open-delay sharing t=0 the switch is overlap-free regardless of the
        // enter/leave event order. .ne-mm-closing drops :hover (pointer-events:none) so the panel
        // runs its normal closed slide. (user 2026-07-07)
        if (prev && prev !== item) forceClose(prev);
        // AUTHORITATIVE OPEN — drive the panel from .is-open (JS), NOT :hover. The sidebar's
        // overlapping vertical hover-pads left the OUTGOING item STALE-:hover (Firefox drops :hover
        // only on the next hit-test, so a cursor RESTING on the incoming never clears the neighbour's
        // :hover) → its :hover-keyed open rule re-showed its panel UNDER the incoming = the residual
        // "first hover→hover overlap". A JS class can't go stale: onEnter adds it here + forceClose
        // removed it from prev ⇒ exactly one panel open at any instant. :focus-within stays in the CSS
        // for keyboard a11y. (user 2026-07-08)
        item.classList.add('is-open');
        openItem = item;
        openSince = now;
        openDelay = delay;
        /* Beim OEFFNEN den Kopfversatz frisch schreiben. Damit darf er waehrend des
           Scrollens veralten (siehe refreshHeaderMetricsSoon), ohne dass ein Panel je
           auf einem alten Wert aufsetzt. */
        publishHeaderBottom();
        if (isSidebar) positionSoon(item);
      }
      function forceClose(it) {
        it.classList.add('ne-mm-closing');
        it.classList.remove('is-open');
        // Sidebar: keep .ne-mm-closing PERSISTENT. The vertical hover-pads keep an adjacent item
        // stale-:hover while the cursor rests on its neighbour, so a TIMED removal let the outgoing
        // panel RE-OPEN under the incoming (the lingering second panel in the switch). The direct-
        // force close rule pins it shut regardless of :hover; it is lifted in onEnter on a genuine
        // re-enter. Top header keeps the timed removal — its horizontal pads don't stale-hover so.
        if (isSidebar) return;
        if (it.__neFcT) clearTimeout(it.__neFcT);
        it.__neFcT = setTimeout(function () { it.classList.remove('ne-mm-closing'); }, CLOSE + 40);
      }
      function onLeave(item) {
        if (openItem === item) {
          var now = Date.now();
          // Only a panel that actually OPENED (dwelt past its open-delay) counts as "closing" for the
          // next switch — a graze that left before its intent elapsed never showed, so it must not
          // make the next item wait CLOSE ms.
          if (now - openSince >= openDelay) { closingItem = item; closingSince = now; }
          // Authoritative close: drop .is-open so the panel runs its normal 300ms slide-back. A graze
          // that leaves before its open-delay elapsed removes .is-open before the slide starts → no flash.
          item.classList.remove('is-open');
          openItem = null;
        }
      }
      var items = nav.querySelectorAll('.ne-header__nav-item');
      for (var i = 0; i < items.length; i++) {
        (function (item) {
          if (!item.querySelector(':scope > .ne-header__megamenu, :scope > .ne-header__dropdown')) return;
          // Only TOP-LEVEL nav items drive the seam-slide stagger. A NESTED item (a "More" child clone
          // lives inside the More megamenu) must NOT be treated as a sibling switch — otherwise entering
          // it force-closes its own ancestor More panel. Nested items open as base side-flyouts instead
          // (initMoreFlyoutFlip + base sb-mega rules), so leave them out here entirely. (user 2026-07-08)
          if (item.closest('.ne-header__megamenu, .ne-header__dropdown')) return;
          item.addEventListener('mouseenter', function () { onEnter(item); });
          item.addEventListener('focusin', function () { if (isSidebar) positionSoon(item); });
          item.addEventListener('mouseleave', function () { onLeave(item); });
        })(items[i]);
      }
    }

    function init() {
      run();
      bindNavClose();
      initMergeStagger();
      if (state.markerObs) { state.markerObs.disconnect(); state.markerObs = null; }
      if (state.islandsObs) { state.islandsObs.disconnect(); state.islandsObs = null; }
      var marker = document.querySelector('[data-ne-header-sync]');
      if (marker) {
        state.markerObs = new MutationObserver(function () { run(); });
        state.markerObs.observe(marker, { attributes: true });
      }
      var islands = document.querySelector('[data-ne-block-islands]');
      if (islands) {
        state.islandsObs = new MutationObserver(function () { run(); });
        state.islandsObs.observe(islands, { childList: true, subtree: true, attributes: true });
      }
    }

    // Body-level safety observer: if the Customizer replaces the menu-block
    // DOM without our script re-executing (block-only refresh), the marker
    // and islands nodes above are detached and our observers go silent.
    // A single persistent observer on <body> catches the swap and re-inits.
    //
    // ⚠️ NUR im Customizer. Der Fall, den dieser Beobachter abfaengt — ein Block-Austausch
    // ohne Neuausfuehrung des Skripts — kann auf der Storefront nicht eintreten; dort gibt
    // es keinen `shopify:block:*`-Lebenszyklus. Ein `subtree: true`-Beobachter auf dem
    // GANZEN `<body>` laeuft aber bei jeder DOM-Aenderung mit, und dieses Theme aendert das
    // DOM viel (Quick-View, Warenkorb-Schublade, Varianten, Scroll-Effekte). Auf 21rebel
    // hat Lighthouse den Boot-Pfad dieses Skripts als groessten Einzelposten unter
    // "Forced reflow" gemeldet. Kein Verhaltensunterschied auf der Storefront.
    function ensureBodyObserver() {
      if (!(window.Shopify && window.Shopify.designMode)) return;
      if (state.bodyObs) return;
      state.bodyObs = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var added = mutations[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (n.matches && (n.matches('[data-ne-header-sync]') || n.matches('[data-ne-block-islands]'))) { init(); return; }
            if (n.querySelector && (n.querySelector('[data-ne-header-sync]') || n.querySelector('[data-ne-block-islands]'))) { init(); return; }
          }
        }
      });
      state.bodyObs.observe(document.body, { childList: true, subtree: true });
    }

    function boot() { init(); ensureBodyObserver(); }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', init);
    document.addEventListener('shopify:block:deselect', run);

    // Keep --ne-header-bottom + --ne-header-sidebar-width fresh when the
    // header's position/size changes (sticky-smart hide/show, floating-offset
    // transitions, resize, font-loading width shifts).
    function refreshHeaderMetrics() {
      publishHeaderBottom();
      publishSidebarWidth();
    }
    /* ⚠️ Scroll-Ereignisse feuern oefter als Frames gezeichnet werden. Beide
       Funktionen LESEN Geometrie und SCHREIBEN danach auf `:root` — ungebuendelt
       ist das Lesen-nach-Schreiben pro Ereignis (Rule 534) plus eine dokumentweite
       Invalidierung pro Ereignis (Rule 533). Auf einen Frame gebuendelt bleibt
       hoechstens eine Runde pro gezeichnetem Bild, und der Wertvergleich in den
       Funktionen entfernt davon noch die, bei denen sich nichts geaendert hat. */
    var _metricsGeplant = false;
    function refreshHeaderMetricsSoon() {
      if (_metricsGeplant) return;
      _metricsGeplant = true;
      requestAnimationFrame(function () { _metricsGeplant = false; refreshHeaderMetrics(); });
    }

    /* ⚠️ Beim SCROLLEN muss der Wert nur dort pro Frame mitlaufen, wo ihn etwas live
       verbraucht. Verbraucher von `--ne-header-bottom` sind:
         · Dropdown/Megamenu-Versatz — nur bei GEOEFFNETEM Panel, und das wird jetzt
           beim Oeffnen frisch geschrieben (siehe onEnter). Auf Mobil ist das Menue
           ohnehin ein <dialog> mit `scroll-lock`, dort ist Scrollen bei offenem Menue
           gar nicht moeglich (User-Einwand 29.07., am Markup bestaetigt).
         · die mobile Hero-Hoehe (Rule 506) — ein Layoutwert am Seitenanfang.
         · `[data-ne-scroll-motion~="stack"]` → `position: sticky; top: …` — DER braucht
           ihn wirklich pro Frame, sonst parken die klebenden Sections falsch.
       Nur fuer den letzten Fall laeuft es weiter pro Frame. Sonst reicht das Scroll-ENDE:
       im Trace vom 29.07. war publishHeaderBottom mit 78 Aufrufen und 359 ms der groesste
       Einzelposten der Stilneuberechnung, und jeder Aufruf entwertet den Stil des ganzen
       Dokuments (Rule 533). Auf 21rebel ist der Stapel-Effekt aus — dort faellt das damit
       auf zwei Aufrufe. */
    function stapelEffektAn() {
      var v = document.documentElement.getAttribute('data-ne-scroll-motion') || '';
      return v.split(/\s+/).indexOf('stack') !== -1;
    }
    var _scrollEndeTimer = null;
    function beiScroll() {
      if (stapelEffektAn()) { refreshHeaderMetricsSoon(); return; }
      if (_scrollEndeTimer) clearTimeout(_scrollEndeTimer);
      _scrollEndeTimer = setTimeout(function () {
        _scrollEndeTimer = null; refreshHeaderMetricsSoon();
      }, 120);
    }
    window.addEventListener('resize', refreshHeaderMetricsSoon);
    window.addEventListener('scroll', beiScroll, { passive: true });

    // Scroll-idle nav reveal (opt-in): hide the nav points WHILE scrolling, bring
    // them back when the scroll settles — a motion parallel to the hover-reveal
    // (user 2026-07-11). Adds .ne-header--nav-scrolling on scroll, drops it after
    // an idle delay; the CSS fades .ne-header__nav on that class.
    var _navIdleTimer = null;
    function onNavScroll() {
      var hs = document.querySelectorAll('.ne-header--nav-scroll-reveal');
      if (!hs.length) return;
      for (var i = 0; i < hs.length; i++) hs[i].classList.add('ne-header--nav-scrolling');
      if (_navIdleTimer) clearTimeout(_navIdleTimer);
      _navIdleTimer = setTimeout(function () {
        var h2 = document.querySelectorAll('.ne-header--nav-scroll-reveal');
        for (var j = 0; j < h2.length; j++) h2[j].classList.remove('ne-header--nav-scrolling');
      }, 420);
    }
    window.addEventListener('scroll', onNavScroll, { passive: true });
  })();
